import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import FeaturedOffers from "../components/FeaturedOffers";
import { useSiteSettings } from "../contexts/SiteSettingsContext";
import { useBestSellers, useFeaturedProducts, useFeaturedTemplates, useFestiveSpecials, useHotSelling, useInhousePublications, useNewArrivals } from "../hooks/useApi";
import useSEO from "../hooks/useSEO";
import apiService from "../services/api";

const slides = [
    {
        image: "https://res.cloudinary.com/dyx5inb2u/image/upload/v1762036137/x1_slslsw.png",
        mobileImage: "https://res.cloudinary.com/dyx5inb2u/image/upload/v1762036137/x01_yob9us.png",
        headline: (
            <>
                Say hello to new
                <br />
                Matte Paper Stickers
            </>
        ),
        subheadline: "Uncoated, plastic free and 100% recyclable.",
        button: "Shop Stickers",
        buttonLink: "/subcategory/customized-stickers",
        navLinks: ["Matte Paper Round Stickers", "Matte Paper Rectangular Stickers"],
    },
    {
        image: "https://res.cloudinary.com/dyx5inb2u/image/upload/v1762036138/x2_uv5lur.png",
        mobileImage: "https://res.cloudinary.com/dyx5inb2u/image/upload/v1762036138/x02_fgfbjt.png",
        headline: <>Premium Business Cards</>,
        subheadline: "Starting @ 250 Rs. Only with One Day Delivery",
        button: "Shop Business Cards",
        buttonLink: "/subcategory/visiting-cards",
        navLinks: [
            "Basic Business Cards",
            "Standard Business Cards",
            "Classic Business Cards",
            "Premium & Superior Cards",
        ],
    },
    {
        image: "https://res.cloudinary.com/dyx5inb2u/image/upload/v1762036137/x3_lo4jlz.png",
        mobileImage: "https://res.cloudinary.com/dyx5inb2u/image/upload/v1762036139/x03_ivhazk.png",
        headline: <>Creative Postcards & Flyers</>,
        subheadline: "Stand out with vibrant, custom-printed marketing materials.",
        button: "Shop Postcards & Flyers",
        buttonLink: "/subcategory/marketing-essentials",
        navLinks: ["US Letter Flyers", "Half Page Flyers", "Premium Flyers", "Pearlescent Flyers"],
    },
    // {
    //     image: "https://res.cloudinary.com/dyx5inb2u/image/upload/v1762036139/x4_sgvqfq.png",
    //     mobileImage: "https://res.cloudinary.com/dyx5inb2u/image/upload/v1762036137/x04_boner8.png",
    //     headline: <>Creative Postcards & Flyers</>,
    //     subheadline: "Stand out with vibrant, custom-printed marketing materials.",
    //     button: "Shop Postcards & Flyers",
    //     buttonLink: "/subcategory/marketing-essentials",
    //     navLinks: ["US Letter Flyers", "Half Page Flyers", "Premium Flyers", "Pearlescent Flyers"],
    // },
];

// const popularProducts = [
//     {
//         image: "/businesscard.jpg",
//         label: "Shop Business Cards",
//         href: "/category/visiting-cards",
//     },
//     {
//         image: "https://placehold.co/300x300?text=Custom+Stickers",
//         label: "Shop Custom Stickers",
//         href: "/category/customized-stickers",
//     },
//     {
//         image: "https://placehold.co/300x300?text=Wedding+Invites",
//         label: "Shop Wedding & Invites",
//         href: "/category/invitations",
//     },
//     {
//         image: "https://placehold.co/300x300?text=Labels",
//         label: "Shop Labels & Packaging",
//         href: "/category/marketing-essentials",
//     },
//     {
//         image: "https://placehold.co/300x300?text=Posters",
//         label: "Shop Posters & Marketing",
//         href: "/category/marketing-essentials",
//     },
//     {
//         image: "https://placehold.co/300x300?text=Stationery",
//         label: "Shop Custom Stationery",
//         href: "/category/custom-stationary",
//     },
//     {
//         image: "https://placehold.co/300x300?text=Office",
//         label: "Shop Office Essentials",
//         href: "/category/office-essentials",

//     },
// ];

// New pricing data based on the image
const businessCardPricing = {
    categories: ["Basic", "Standard", "Classic", "Premium", "Superior", "Luxury"],
    types: [
        { category: "Basic", type: "250 Gsm Front", prices: [250, 400, 550, 900, 1200] },
        { category: "Basic", type: "250 Gsm Front & Back", prices: [350, 600, 750, 1000, 1500] },
        { category: "Standard", type: "300 Gsm Front", prices: [300, 500, 600, 1000, 1700] },
        { category: "Standard", type: "300 Gsm Front & Back", prices: [450, 600, 800, 1200, 1900] },
        { category: "Standard", type: "300 Gsm With Lamination Front", prices: [350, 500, 700, 1100, 1800] },
        { category: "Standard", type: "300 Gsm With Lamination F & B", prices: [400, 700, 900, 1400, 2000] },
        { category: "Classic", type: "350 Gsm Front", prices: [350, 600, 700, 1100, 1800] },
        { category: "Classic", type: "350 Gsm Front & Back", prices: [500, 700, 900, 1300, 2000] },
        { category: "Classic", type: "350 Gsm With Lamination Front", prices: [400, 600, 800, 1200, 1900] },
        { category: "Classic", type: "350 Gsm With Lamination F & B", prices: [500, 700, 900, 1300, 2000] },
        { category: "Premium", type: "Ahivory Front (Japan / Korean)", prices: [400, 700, 1000, 1500, 2200] },
        { category: "Premium", type: "Ahivory Front & Back", prices: [500, 800, 1200, 1700, 2500] },
        { category: "Superior", type: "Non Terable Front", prices: [400, 700, 1000, 1500, 2200] },
        { category: "Superior", type: "Non Terable Front & Back", prices: [500, 800, 1200, 1700, 2500] },
        { category: "Luxury", type: "Textured Paper Front", prices: [500, 800, 1200, 1700, 2500] },
        { category: "Luxury", type: "Textured Paper Front & Back", prices: [600, 1000, 1400, 2000, 2800] },
    ],
    quantities: [100, 200, 300, 500, 1000],
};

// FAQ data
const faqs = [
    {
        question: "How fast is delivery?",
        answer: "We offer One Day Delivery on selected products. Order before 2PM for next day delivery.",
    },
    {
        question: "What is the Kigo Prints promise?",
        answer: "We are your One-Stop Solution for Quality Printing!",
    },
    {
        question: "Do you offer design services?",
        answer: "Yes, design charges are extra applicable at Rs. 150 per side.",
    },
    {
        question: "What payment methods do you accept?",
        answer: "We accept Paytm, credit cards, UPI and other online payment methods.",
    },
];

const categories = [
    {
        name: "Custom Stickers",
        slug: "customized-stickers",
        image: "https://i.pinimg.com/736x/bd/60/84/bd6084b209827dda8f8c26bac7cbb6cc.jpg",
        subcategories: ["Non-Tearable Stickers", "Paper Stickers", "Custom Shape Stickers", "Window Stickers"],
    },
    {
        name: "Visiting Cards",
        slug: "visiting-cards",
        image: "https://i.pinimg.com/736x/9b/15/8d/9b158d1130926eb6ab0a9f62b96c7a6b.jpg",
        subcategories: ["Standard", "Premium", "Textured"],
    },
    {
        name: "Invitations",
        slug: "invitations",
        image: "https://i.pinimg.com/736x/40/e4/fa/40e4faa86c26347190d37f84753cf3aa.jpg",
        subcategories: ["Wedding", "Party", "Thank You", "Customized"],
    },
    {
        name: "Marketing Essentials",
        slug: "marketing-essentials",
        image: "https://i.pinimg.com/736x/b0/0e/6b/b00e6b87b94fcec4d8d5a72d53ac9a91.jpg",
        subcategories: ["Posters", "Flyers", "Brochures", "Booklets", "Folders", "Banners", "Standees"],
    },
    {
        name: "Custom Stationary",
        slug: "custom-stationary",
        image: "https://i.pinimg.com/736x/be/c4/7c/bec47c839f5b02e179656518ea943640.jpg",
        subcategories: ["Folders", "Lanyards", "ID Cards", "Note Pads", "Wrist Bands", "Certificates", "Danglers"],
    },
    {
        name: "Office Essentials",
        slug: "office-essentials",
        image: "https://i.pinimg.com/736x/25/c9/f0/25c9f010370bac25b9f55ad743155df6.jpg",
        subcategories: ["Letterheads", "Bill Books", "Vouchers", "Tent Cards", "Table Calendars", "Manuals"],
    },
];

const shapeOptions = [
    {
        name: "Original Business Cards",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="3" y="4" width="18" height="18" rx="2"></rect>
                <path d="M16 2v4M8 2v4M3 10h18"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Business+Cards",
        pricing: "50 cards from $22.00",
        features: [
            "16pt thickness",
            'our "feel good" premium paper',
            "available in matte or gloss finish",
            "great quality and great value",
            "fsc® certified"
        ],
        details: {
            size: "Standard",
            actions: ["Select design", "Upload photos"],
        },
    },
    {
        name: "Original Business Cards",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M5 3v18h14V3z"></path>
                <path d="M9 3v18"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Business+Cards",
        pricing: "50 cards from $22.00",
        features: [
            "16pt thickness",
            'our "feel good" premium paper',
            "available in matte or gloss finish",
            "great quality and great value",
            "fsc® certified"
        ],
        details: {
            note: "Details pending",
        },
    },
    {
        name: "Original Business Cards",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                <path d="M8 8h8M8 12h8M8 16h5"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Business+Cards",
        pricing: "50 cards from $22.00",
        features: [
            "16pt thickness",
            'our "feel good" premium paper',
            "available in matte or gloss finish",
            "great quality and great value",
            "fsc® certified"
        ],
        details: {
            sizes: ["A4", "A5"],
            pages: [4, 6, 8, 10],
            finish: ["Gloss", "Matt"],
        },
    },
    {
        name: "Original Business Cards",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M4 7h16M4 11h16M4 15h10"></path>
                <rect x="2" y="3" width="20" height="18" rx="2"></rect>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Business+Cards",
        pricing: "50 cards from $22.00",
        features: [
            "16pt thickness",
            'our "feel good" premium paper',
            "available in matte or gloss finish",
            "great quality and great value",
            "fsc® certified"
        ],
        details: {
            sizes: ["A4", "A5"],
            types: ["Wedding invitations", "Party invitations", "Thank you cards", "Fold invitations"],
        },
    },
    {
        name: "Paper Wristbands",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M3 12h18"></path>
                <rect x="6" y="8" width="12" height="8" rx="2"></rect>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Wristbands",
        details: {
            size: "Standard",
            action: "Upload details",
        },
    },
];
// ...existing code...
const paperOptions = [
    {
        name: "Flyers / Leaflets",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                <path d="M8 8h8M8 12h8"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Flyers",
        details: {
            sizes: ["A4", "A5"],
            colour: "Multicolour (Standard)",
        },
    },
    {
        name: "Brochures",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M3 4h7v16H3zM14 4h7v16h-7z"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Brochures",
        details: {
            sizes: ["A4", "A5"],
            fold: ["None", "Fold", "Tri-fold"],
        },
    },
    {
        name: "Banners",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="2" y="6" width="20" height="12" rx="2"></rect>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Banners",
        details: {
            size: "Custom",
        },
    },
    {
        name: "Standies",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="4" y="3" width="16" height="12" rx="1"></rect>
                <path d="M8 15v4h8v-4"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Standies",
        details: {
            size: "To be confirmed",
            variants: ["Floor standies", "Table top standies"],
        },
    },
    {
        name: "Danglers",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <circle cx="12" cy="8" r="4"></circle>
                <rect x="6" y="12" width="12" height="8" rx="2"></rect>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Danglers",
        details: {
            shape: ["Square", "Circle"],
            size: "Standard",
        },
    },
    {
        name: "Certificates",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="3" y="4" width="18" height="14" rx="2"></rect>
                <path d="M8 20l4-4 4 4"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Certificates",
        details: {
            sizes: ["A4", "A3"],
        },
    },
];
// ...existing code...
const specialtyOptions = [
    {
        name: "Letterhead",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                <path d="M7 7h10M7 11h10"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Letterhead",
        details: {
            size: "A4 (Standard)",
            colour: "Multicolour",
        },
    },
    {
        name: "Bill Book",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M3 4h18v16H3z"></path>
                <path d="M8 8h8M8 12h8"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Bill+Book",
        details: {
            sizes: ["A4", "A5"],
            colour: ["Single", "Multicolour"],
        },
    },
    {
        name: "ID Cards",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                <circle cx="12" cy="9" r="2"></circle>
                <path d="M7 15c1.5-2 8-2 10 0"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=ID+Cards",
        details: {
            size: "Standard",
            orientation: ["Vertical", "Horizontal"],
        },
    },
    {
        name: "Tent Cards",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M3 20h18L12 4z"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Tent+Cards",
        details: {
            size: "A5 (Standard)",
            sides: "Front & Back (Standard)",
        },
    },
    {
        name: "Office Table Calendars",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="4" y="6" width="16" height="14" rx="2"></rect>
                <path d="M8 2v4M16 2v4"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Office+Calendar",
        details: {
            size: "Standard",
            actions: ["Select design", "Upload logo"],
        },
    },
    {
        name: "Envelopes",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                <path d="M22 6l-10 7L2 6"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Envelopes",
        details: {
            size: "10 x 4",
            colour: "Multicolour",
        },
    },
    {
        name: "Window Envelopes",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                <rect x="4" y="8" width="6" height="4" rx="1"></rect>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Window+Envelopes",
        details: {
            size: "10 x 4",
            colour: "Multicolour",
            windowPosition: ["Left top", "Left center", "Left bottom"],
        },
    },
    {
        name: "Presentation Folders",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M3 4h6l2 3h10v13H3z"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Folders",
        details: {
            size: "Standard",
        },
    },
    {
        name: "Note Pads",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <rect x="4" y="3" width="16" height="18" rx="2"></rect>
                <path d="M8 7h8M8 11h8"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Notepads",
        details: {
            sizes: ["A4", "A5"],
        },
    },
    {
        name: "Lanyards",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M12 2v6"></path>
                <path d="M8 10v4a4 4 0 0 0 8 0v-4"></path>
            </svg>
        ),
        image: "https://placehold.co/600x600?text=Lanyards",
        details: {
            action: "Upload logo",
            MOQ: 30,
        },
    },
];

const LandingPageV4 = () => {
    const { isComingSoon, isUnderMaintenance, isNotAcceptingOrders, loading: settingsLoading } = useSiteSettings();
    const [current, setCurrent] = useState(0);
    const [banners, setBanners] = useState([]);
    const [bannersLoading, setBannersLoading] = useState(true);

    // Use banners if available, otherwise fallback to hardcoded slides
    const activeSlides = banners.length > 0 ? banners : slides;
    const slide = activeSlides[current] || activeSlides[0] || slides[0];

    const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';

    useSEO({
        title: 'Kigo Prints - Professional Printing Services in India | Business Cards, Stickers & More',
        description: 'Kigo Prints offers premium printing services in India. Get high-quality business cards, stickers, flyers, posters, and custom printing solutions with fast delivery. Professional printing at affordable prices.',
        keywords: 'printing services, business cards, stickers, flyers, posters, custom printing, printing India, professional printing, Kigo Prints, online printing, print shop',
        image: slide?.image || `${baseUrl}/logo_white_theme.png`,
        structuredData: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            'name': 'Kigo Prints',
            'url': baseUrl,
            'logo': `${baseUrl}/logo_white_theme.png`,
            'description': 'Professional printing services in India offering business cards, stickers, flyers, posters, and custom printing solutions.',
            'address': {
                '@type': 'PostalAddress',
                'addressCountry': 'IN'
            },
            'areaServed': {
                '@type': 'Country',
                'name': 'India'
            },
            'sameAs': []
        }
    });
    const [isLoaded, setIsLoaded] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [mobileSubMenuOpen, setMobileSubMenuOpen] = useState(false);
    const timerRef = useRef(null);
    const slideInterval = 5000; // 5 seconds per slide
    const [isMobile, setIsMobile] = useState(false);
    const [displayCategories, setDisplayCategories] = useState(categories);
    const [categoriesLoading, setCategoriesLoading] = useState(false);
    const [categoriesError, setCategoriesError] = useState(null);
    const [hotSellingCurrentIndex, setHotSellingCurrentIndex] = useState(0);
    const hotSellingTouchStart = useRef(null);
    const hotSellingTouchEnd = useRef(null);
    const hotSellingTouchStartY = useRef(null);
    const [festiveSpecialsCurrentIndex, setFestiveSpecialsCurrentIndex] = useState(0);
    const festiveSpecialsTouchStart = useRef(null);
    const festiveSpecialsTouchEnd = useRef(null);
    const festiveSpecialsTouchStartY = useRef(null);
    const [designTemplatesCurrentIndex, setDesignTemplatesCurrentIndex] = useState(0);
    const designTemplatesTouchStart = useRef(null);
    const designTemplatesTouchEnd = useRef(null);
    const designTemplatesTouchStartY = useRef(null);
    const [inhousePublicationsCurrentIndex, setInhousePublicationsCurrentIndex] = useState(0);
    const inhousePublicationsTouchStart = useRef(null);
    const inhousePublicationsTouchEnd = useRef(null);
    const inhousePublicationsTouchStartY = useRef(null);

    // API hooks for dynamic data
    const { data: featuredProducts, loading: featuredLoading, error: featuredError } = useFeaturedProducts();
    const { data: newArrivals, loading: newArrivalsLoading, error: newArrivalsError } = useNewArrivals();
    const { data: bestSellers, loading: bestSellersLoading, error: bestSellersError } = useBestSellers();
    const { data: hotSellingData, loading: hotSellingLoading, error: hotSellingError } = useHotSelling();
    const { data: festiveSpecialsData, loading: festiveSpecialsLoading, error: festiveSpecialsError } = useFestiveSpecials();
    const { data: featuredTemplatesData, loading: featuredTemplatesLoading, error: featuredTemplatesError } = useFeaturedTemplates();
    const { data: inhousePublicationsData, loading: inhousePublicationsLoading, error: inhousePublicationsError } = useInhousePublications();

    // Fetch banners from database
    useEffect(() => {
        const fetchBanners = async () => {
            setBannersLoading(true);
            try {
                const response = await apiService.getHomeHeroBanners();
                console.log('Banner API response:', response);
                if (response.status === 'success' && response.data.banners && response.data.banners.length > 0) {
                    const formattedBanners = response.data.banners.map(banner => ({
                        image: banner.image?.url || '',
                        mobileImage: banner.mobileImage?.url || banner.image?.url || '',
                        headline: banner.headline || '',
                        subheadline: banner.subheadline || '',
                        button: banner.buttonText || '',
                        buttonLink: banner.buttonLink || '',
                        navLinks: banner.navLinks || []
                    }));
                    console.log('Formatted banners:', formattedBanners);
                    setBanners(formattedBanners);
                    setCurrent(0); // Reset to first slide when banners load
                } else {
                    console.log('No banners found in database, using hardcoded slides');
                }
            } catch (error) {
                console.error('Failed to fetch banners:', error);
            } finally {
                setBannersLoading(false);
            }
        };
        fetchBanners();
    }, []);

    // Fetch active categories from database
    useEffect(() => {
        const fetchCategories = async () => {
            setCategoriesLoading(true);
            setCategoriesError(null);
            try {
                const response = await apiService.request('/products/categories/active');
                if (response.status === 'success' && response.data.categories) {
                    const formattedCategories = response.data.categories.map(cat => {
                        const categoryName = cat.name.split('-').map(word =>
                            word.charAt(0).toUpperCase() + word.slice(1)
                        ).join(' ');

                        // Try to find matching static category for subcategories
                        const staticCat = categories.find(staticCat =>
                            staticCat.slug === cat.name ||
                            staticCat.name.toLowerCase() === categoryName.toLowerCase()
                        );

                        return {
                            name: categoryName,
                            slug: cat.name,
                            image: cat.image?.url || staticCat?.image || "https://placehold.co/300x300?text=" + encodeURIComponent(categoryName),
                            subcategories: staticCat?.subcategories || []
                        };
                    });
                    setDisplayCategories(formattedCategories);
                }
            } catch (error) {
                console.error('Failed to fetch categories:', error);
                setCategoriesError(error);
                // Keep using static categories as fallback
            } finally {
                setCategoriesLoading(false);
            }
        };
        fetchCategories();
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    // Auto-sliding functionality
    useEffect(() => {
        setIsLoaded(true);

        // Start the timer for auto-sliding
        const startTimer = () => {
            timerRef.current = setTimeout(() => {
                setCurrent(prevCurrent => (prevCurrent + 1) % activeSlides.length);
            }, slideInterval);
        };

        // Only start timer if not paused
        if (!isPaused) {
            startTimer();
        }

        // Cleanup function
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [current, isPaused, activeSlides.length]);

    // Handle scroll for sticky navbar
    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 80) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Close mobile menu when window resizes to desktop size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setMobileMenuOpen(false);
                setMobileSubMenuOpen(false);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Handle manual slide change
    const handleSlideChange = index => {
        // Clear existing timer
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        // Set new slide
        setCurrent(index);
    };

    // Hot Selling Slider Handlers
    const hotSellingProducts = hotSellingData?.data?.products || [];
    const hotSellingTotal = Math.min(hotSellingProducts.length, 4);

    const handleHotSellingNext = () => {
        if (hotSellingTotal === 0) return;
        setHotSellingCurrentIndex((prev) => (prev + 1) % hotSellingTotal);
    };

    const handleHotSellingPrev = () => {
        if (hotSellingTotal === 0) return;
        setHotSellingCurrentIndex((prev) => (prev - 1 + hotSellingTotal) % hotSellingTotal);
    };

    const handleHotSellingTouchStart = (e) => {
        hotSellingTouchStart.current = e.touches[0].clientX;
        hotSellingTouchStartY.current = e.touches[0].clientY;
        hotSellingTouchEnd.current = null;
    };

    const handleHotSellingTouchMove = (e) => {
        if (!hotSellingTouchStart.current || !hotSellingTouchStartY.current) return;
        hotSellingTouchEnd.current = e.touches[0].clientX;

        // Prevent vertical scrolling during horizontal swipe
        const deltaX = Math.abs(e.touches[0].clientX - hotSellingTouchStart.current);
        const deltaY = Math.abs(e.touches[0].clientY - hotSellingTouchStartY.current);
        if (deltaX > deltaY && deltaX > 10) {
            e.preventDefault();
        }
    };

    const handleHotSellingTouchEnd = () => {
        if (!hotSellingTouchStart.current || !hotSellingTouchEnd.current) return;

        const distance = hotSellingTouchStart.current - hotSellingTouchEnd.current;
        const minSwipeDistance = 50;

        if (distance > minSwipeDistance) {
            handleHotSellingNext();
        } else if (distance < -minSwipeDistance) {
            handleHotSellingPrev();
        }

        hotSellingTouchStart.current = null;
        hotSellingTouchStartY.current = null;
        hotSellingTouchEnd.current = null;
    };

    // Reset slider index when products data changes
    useEffect(() => {
        if (hotSellingProducts.length > 0) {
            setHotSellingCurrentIndex(0);
        }
    }, [hotSellingProducts.length]);

    // Festive Specials Slider Handlers
    const festiveSpecialsProducts = festiveSpecialsData?.data?.products || [];
    const festiveSpecialsTotal = Math.min(festiveSpecialsProducts.length, 4);

    const handleFestiveSpecialsNext = () => {
        if (festiveSpecialsTotal === 0) return;
        setFestiveSpecialsCurrentIndex((prev) => (prev + 1) % festiveSpecialsTotal);
    };

    const handleFestiveSpecialsPrev = () => {
        if (festiveSpecialsTotal === 0) return;
        setFestiveSpecialsCurrentIndex((prev) => (prev - 1 + festiveSpecialsTotal) % festiveSpecialsTotal);
    };

    const handleFestiveSpecialsTouchStart = (e) => {
        festiveSpecialsTouchStart.current = e.touches[0].clientX;
        festiveSpecialsTouchStartY.current = e.touches[0].clientY;
        festiveSpecialsTouchEnd.current = null;
    };

    const handleFestiveSpecialsTouchMove = (e) => {
        if (!festiveSpecialsTouchStart.current || !festiveSpecialsTouchStartY.current) return;
        festiveSpecialsTouchEnd.current = e.touches[0].clientX;

        // Prevent vertical scrolling during horizontal swipe
        const deltaX = Math.abs(e.touches[0].clientX - festiveSpecialsTouchStart.current);
        const deltaY = Math.abs(e.touches[0].clientY - festiveSpecialsTouchStartY.current);
        if (deltaX > deltaY && deltaX > 10) {
            e.preventDefault();
        }
    };

    const handleFestiveSpecialsTouchEnd = () => {
        if (!festiveSpecialsTouchStart.current || !festiveSpecialsTouchEnd.current) return;

        const distance = festiveSpecialsTouchStart.current - festiveSpecialsTouchEnd.current;
        const minSwipeDistance = 50;

        if (distance > minSwipeDistance) {
            handleFestiveSpecialsNext();
        } else if (distance < -minSwipeDistance) {
            handleFestiveSpecialsPrev();
        }

        festiveSpecialsTouchStart.current = null;
        festiveSpecialsTouchStartY.current = null;
        festiveSpecialsTouchEnd.current = null;
    };

    // Reset slider index when products data changes
    useEffect(() => {
        if (festiveSpecialsProducts.length > 0) {
            setFestiveSpecialsCurrentIndex(0);
        }
    }, [festiveSpecialsProducts.length]);

    // Design Templates Slider Handlers
    const designTemplatesList = featuredTemplatesData?.data?.templates || [];
    const designTemplatesTotal = Math.min(designTemplatesList.length, 4);

    const handleDesignTemplatesNext = () => {
        if (designTemplatesTotal === 0) return;
        setDesignTemplatesCurrentIndex((prev) => (prev + 1) % designTemplatesTotal);
    };

    const handleDesignTemplatesTouchStart = (e) => {
        designTemplatesTouchStart.current = e.touches[0].clientX;
        designTemplatesTouchStartY.current = e.touches[0].clientY;
        designTemplatesTouchEnd.current = null;
    };

    const handleDesignTemplatesTouchMove = (e) => {
        if (!designTemplatesTouchStart.current || !designTemplatesTouchStartY.current) return;
        designTemplatesTouchEnd.current = e.touches[0].clientX;

        // Prevent vertical scrolling during horizontal swipe
        const deltaX = Math.abs(e.touches[0].clientX - designTemplatesTouchStart.current);
        const deltaY = Math.abs(e.touches[0].clientY - designTemplatesTouchStartY.current);
        if (deltaX > deltaY && deltaX > 10) {
            e.preventDefault();
        }
    };

    const handleDesignTemplatesTouchEnd = () => {
        if (!designTemplatesTouchStart.current || !designTemplatesTouchEnd.current) return;

        const distance = designTemplatesTouchStart.current - designTemplatesTouchEnd.current;
        const minSwipeDistance = 50;

        if (distance > minSwipeDistance) {
            handleDesignTemplatesNext();
        } else if (distance < -minSwipeDistance) {
            setDesignTemplatesCurrentIndex((prev) => (prev - 1 + designTemplatesTotal) % designTemplatesTotal);
        }

        designTemplatesTouchStart.current = null;
        designTemplatesTouchStartY.current = null;
        designTemplatesTouchEnd.current = null;
    };

    // Reset slider index when templates data changes
    useEffect(() => {
        if (designTemplatesList.length > 0) {
            setDesignTemplatesCurrentIndex(0);
        }
    }, [designTemplatesList.length]);

    // Inhouse Publications Slider Handlers
    const inhousePublicationsList = inhousePublicationsData?.data?.products || [];
    const inhousePublicationsTotal = Math.min(inhousePublicationsList.length, 4);

    const handleInhousePublicationsNext = () => {
        if (inhousePublicationsTotal === 0) return;
        setInhousePublicationsCurrentIndex((prev) => (prev + 1) % inhousePublicationsTotal);
    };

    const handleInhousePublicationsTouchStart = (e) => {
        inhousePublicationsTouchStart.current = e.touches[0].clientX;
        inhousePublicationsTouchStartY.current = e.touches[0].clientY;
        inhousePublicationsTouchEnd.current = null;
    };

    const handleInhousePublicationsTouchMove = (e) => {
        if (!inhousePublicationsTouchStart.current || !inhousePublicationsTouchStartY.current) return;
        inhousePublicationsTouchEnd.current = e.touches[0].clientX;

        // Prevent vertical scrolling during horizontal swipe
        const deltaX = Math.abs(e.touches[0].clientX - inhousePublicationsTouchStart.current);
        const deltaY = Math.abs(e.touches[0].clientY - inhousePublicationsTouchStartY.current);
        if (deltaX > deltaY && deltaX > 10) {
            e.preventDefault();
        }
    };

    const handleInhousePublicationsTouchEnd = () => {
        if (!inhousePublicationsTouchStart.current || !inhousePublicationsTouchEnd.current) return;

        const distance = inhousePublicationsTouchStart.current - inhousePublicationsTouchEnd.current;
        const minSwipeDistance = 50;

        if (distance > minSwipeDistance) {
            handleInhousePublicationsNext();
        } else if (distance < -minSwipeDistance) {
            setInhousePublicationsCurrentIndex((prev) => (prev - 1 + inhousePublicationsTotal) % inhousePublicationsTotal);
        }

        inhousePublicationsTouchStart.current = null;
        inhousePublicationsTouchStartY.current = null;
        inhousePublicationsTouchEnd.current = null;
    };

    // Reset slider index when publications data changes
    useEffect(() => {
        if (inhousePublicationsList.length > 0) {
            setInhousePublicationsCurrentIndex(0);
        }
    }, [inhousePublicationsList.length]);

    if (settingsLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-green-200 border-t-[#008000]"></div>
            </div>
        );
    }

    if (isComingSoon) {
        return (
            <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-100 py-12 px-4">
                <div className="text-center max-w-3xl mx-auto">
                    <div className="mb-8">
                        <div className="mb-6 flex justify-center">
                            <img
                                src="https://i.pinimg.com/originals/e7/72/b3/e772b3d571574c918163db7650bf5f3f.gif"
                                alt="Coming Soon Animation"
                                className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 object-contain"
                            />
                        </div>
                        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-4">
                            Coming Soon
                        </h1>
                        <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto">
                            We're working hard to bring you something amazing. Stay tuned!
                        </p>
                    </div>
                    <div className="mt-12">
                        <p className="text-sm text-gray-500">
                            Thank you for your patience
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Responsive Navigation Bar */}

            {/* Top spacing for content to account for fixed header */}
            {/* <div className="h-16"></div> */}
            {bannersLoading ? (
                <section className="relative w-full h-[60vh] sm:h-[75vh] md:h-[85vh] flex items-center justify-center overflow-hidden bg-gray-200">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center sm:items-start justify-end sm:justify-center h-full relative z-10 pt-0 pb-12 sm:pb-0 sm:pt-16">
                        <div className="w-full sm:max-w-xl text-center sm:text-left absolute bottom-0 left-0 right-0 h-1/2 sm:static sm:h-auto flex flex-col justify-center px-4 sm:px-0">
                            <div className="animate-shimmer h-8 sm:h-16 mb-4 sm:mb-6 rounded-lg bg-gray-300 w-3/4 sm:w-full"></div>
                            <div className="animate-shimmer h-4 sm:h-6 mb-2 sm:mb-4 rounded-lg bg-gray-300 w-full max-w-lg"></div>
                            <div className="animate-shimmer h-4 sm:h-6 mb-4 sm:mb-10 rounded-lg bg-gray-300 w-2/3 sm:w-3/4 max-w-lg"></div>
                            <div className="animate-shimmer h-10 sm:h-14 rounded-lg bg-gray-300 w-32 sm:w-48 mb-4 sm:mb-0"></div>
                            <div className="flex sm:hidden gap-1 justify-center mt-4">
                                {slides.map((_, idx) => (
                                    <div key={idx} className="animate-shimmer w-6 h-1 rounded-full bg-gray-300"></div>
                                ))}
                            </div>
                        </div>
                        <div className="hidden sm:flex gap-2 sm:gap-3 mt-10 sm:mt-16 mb-4 sm:mb-6 justify-center sm:justify-start">
                            {slides.map((_, idx) => (
                                <div key={idx} className="animate-shimmer w-8 sm:w-10 h-1.5 rounded-full bg-gray-300"></div>
                            ))}
                        </div>
                        <div className="hidden sm:flex flex-wrap gap-4 sm:gap-8 mt-4">
                            {slides.slice(0, 4).map((_, idx) => (
                                <div key={idx} className="animate-shimmer h-4 sm:h-5 w-24 sm:w-32 rounded bg-gray-300"></div>
                            ))}
                        </div>
                    </div>
                </section>
            ) : (
                <section
                    className="relative w-full h-[60vh] sm:h-[75vh] md:h-[85vh] flex items-center justify-center overflow-hidden"
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                    style={{
                        fontFamily: '"Bricolage Grotesque", sans-serif',
                    }}
                >
                    {/* Background Image with fade transition */}
                    <AnimatePresence>
                        <motion.div
                            key={current}
                            className="absolute inset-0"
                            style={{
                                backgroundImage: `url(${isMobile
                                    ? slide.mobileImage || slide.image
                                    : slide.image
                                    })`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                            }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.6, ease: "easeInOut" }}
                        />
                    </AnimatePresence>

                    {/* Progress indicator for auto-sliding */}
                    <div className="absolute bottom-0 left-0 w-full h-1 bg-white/10 z-10">
                        <motion.div
                            className="h-full bg-white/40"
                            initial={{ width: "0%" }}
                            animate={{ width: isPaused ? "0%" : "100%" }}
                            transition={{
                                duration: isPaused ? 0 : slideInterval / 1000,
                                ease: "linear",
                                repeat: isPaused ? 0 : 0,
                            }}
                            key={current}
                        />
                    </div>

                    {/* Dynamic gradient overlay for better text contrast */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                        className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50 pointer-events-none"
                    />

                    <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center sm:items-start justify-end sm:justify-center h-full relative z-10 pt-0 pb-12 sm:pb-0 sm:pt-16">
                        {/* Text Block with animations */}
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={current}
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -30 }}
                                transition={{ duration: 0.8 }}
                                className="w-full sm:max-w-xl text-center sm:text-left bg-transparent sm:bg-transparent  sm:backdrop-blur-none sm:p-0 absolute bottom-0 left-0 right-0 h-1/2 sm:static sm:h-auto flex flex-col justify-center px-4 sm:px-0"
                            >
                                <motion.h1
                                    className="text-xl sm:text-5xl md:text-6xl font-bold text-white mb-1 sm:mb-6 leading-tight drop-shadow-lg"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: 0.3 }}
                                >
                                    {typeof slide.headline === 'string' ? slide.headline.split('\n').map((line, i) => (
                                        <React.Fragment key={i}>
                                            {line}
                                            {i < slide.headline.split('\n').length - 1 && <br />}
                                        </React.Fragment>
                                    )) : slide.headline}
                                </motion.h1>

                                <motion.p
                                    className="text-xs sm:text-xl text-white/90 mb-2 sm:mb-10 drop-shadow-md max-w-lg mx-auto sm:mx-0"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: 0.4 }}
                                >
                                    {slide.subheadline}
                                </motion.p>

                                <motion.button
                                    className="px-3 sm:px-10 py-2 sm:py-4 bg-white text-gray-900 rounded-xl shadow-lg hover:bg-gray-100 hover:shadow-xl transition-all duration-300 font-medium text-xs sm:text-lg transform hover:scale-[1.02] mb-4 sm:mb-0"
                                    initial={{ opacity: 0, y: 8 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
                                    whileHover={{ y: -3 }}
                                    whileTap={{ scale: 0.98 }}
                                    onClick={() => window.location.href = slide.buttonLink}
                                >
                                    {slide.button}
                                </motion.button>

                                {/* Mobile Slider Dots - Integrated inside the hero box */}
                                <motion.div
                                    className="flex sm:hidden gap-1 justify-center"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.8, delay: 0.7 }}
                                >
                                    {activeSlides.map((_, idx) => (
                                        <button
                                            key={idx}
                                            className={`w-6 h-1 rounded-full transition-all duration-300 ${idx === current ? "bg-white w-8" : "bg-white/40"
                                                }`}
                                            onClick={() => handleSlideChange(idx)}
                                            aria-label={`Go to slide ${idx + 1}`}
                                        />
                                    ))}
                                </motion.div>
                            </motion.div>
                        </AnimatePresence>

                        {/* Slider Dots with animation - hidden on mobile, shown on sm and up */}
                        <motion.div
                            className="hidden sm:flex gap-2 sm:gap-3 mt-10 sm:mt-16 mb-4 sm:mb-6 justify-center sm:justify-start"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.7 }}
                        >
                            {activeSlides.map((_, idx) => (
                                <button
                                    key={idx}
                                    className={`w-8 sm:w-10 h-1.5 rounded-full transition-all duration-300 ${idx === current ? "bg-white w-12 sm:w-14" : "bg-white/40"
                                        }`}
                                    onClick={() => handleSlideChange(idx)}
                                    aria-label={`Go to slide ${idx + 1}`}
                                />
                            ))}
                        </motion.div>

                        {/* Mobile Slider Dots - smaller and more compact */}
                        {/* <motion.div 
            className="flex sm:hidden gap-1 mt-4 mb-0 justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            {slides.map((_, idx) => (
              <button
                key={idx}
                className={`w-6 h-1 rounded-full transition-all duration-300 ${
                  idx === current ? 'bg-white w-8' : 'bg-white/40'
                }`}
                onClick={() => handleSlideChange(idx)}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </motion.div> */}

                        {/* Product Navigation Links with animations - hidden on mobile */}
                        <AnimatePresence>
                            <motion.div
                                key={`nav-${current}`}
                                className="hidden sm:flex flex-wrap gap-4 sm:gap-8 text-white/90 text-sm sm:text-base font-medium justify-center sm:justify-start"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.6, ease: "easeInOut" }}
                                id="products"
                            >
                                {slide.navLinks.map((link, idx) => (
                                    <motion.a
                                        key={idx}
                                        // href="#"
                                        className="hover:underline hover:text-white transition-colors duration-300"
                                    // whileHover={{ scale: 1.05, x: 5 }}
                                    >
                                        {link}
                                    </motion.a>
                                ))}
                            </motion.div>
                        </AnimatePresence>
                    </div>

                    {/* Slider Arrows with improved styling and animations */}

                    {/* Auto-slide indicator */}
                    {isPaused && (
                        <div className="absolute bottom-4 right-4 bg-white/80 rounded-full p-2 shadow-md z-10">
                            <svg
                                className="w-5 h-5 text-gray-800"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                        </div>
                    )}
                </section>
            )}

            {/* Category Section - Mobile Responsive Enhancements */}
            <section
                className="w-full py-8 sm:py-16 md:py-20 bg-gradient-to-b from-white to-gray-50 "
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <motion.div
                        className="mb-6 sm:mb-8 md:mb-10"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 className="text-xl text-center sm:text-4xl font-bold mb-1 sm:mb-3 sm:text-left">
                            Explore Our Product Range
                        </h2>
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end">
                            <p className="text-sm text-center sm:text-left sm:text-xl text-gray-600 max-w-2xl mb-2 sm:mb-0">
                                Discover our wide selection of products
                            </p>
                            {/* <motion.a
                                href="#"
                                className="text-[#008000] font-medium hidden sm:flex items-center justify-center hover:underline w-max text-sm"
                                whileHover={{ x: 5 }}
                            >
                                View all categories
                                <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                            </motion.a> */}
                        </div>
                    </motion.div>{" "}
                    {/* Scrollable row for mobile, grid for desktop */}
                    <div className="relative -mx-2 pb-4 sm:mx-0 sm:px-0 sm:pb-0">
                        {" "}
                        <div className="flex overflow-x-auto gap-2 sm:gap-6 sm:grid sm:grid-cols-2 md:grid-cols-4 sm:overflow-visible pb-4 sm:pb-0 snap-x snap-mandatory sm:snap-none scrollbar-hide mx-2">
                            {" "}
                            {categoriesLoading ? (
                                // Loading skeleton
                                Array.from({ length: 8 }).map((_, idx) => (
                                    <div key={idx} className="relative flex-shrink-0 w-[120px] sm:w-auto snap-start">
                                        <div className="bg-gray-200 animate-pulse rounded-xl h-[160px] sm:h-[21rem]"></div>
                                    </div>
                                ))
                            ) : categoriesError ? (
                                // Error state
                                <div className="col-span-full text-center py-8">
                                    <p className="text-red-500">Failed to load categories. Using default categories.</p>
                                </div>
                            ) : null}
                            {displayCategories.map((cat, idx) => (
                                <motion.div
                                    key={cat.id || idx}
                                    className="relative group flex-shrink-0 w-[120px] sm:w-auto snap-start"
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5 }}
                                >
                                    {" "}
                                    {/* Mobile Layout: Image on top, title below, explore more at bottom */}
                                    <Link
                                        to={`/subcategory/${cat.slug}`}
                                        className="relative block sm:hidden"
                                    >
                                        <motion.div
                                            className="bg-white rounded-xl shadow-md overflow-hidden h-[160px] flex flex-col group-hover:shadow-lg transition-shadow duration-300"
                                            whileHover={{ y: -2 }}
                                            transition={{ duration: 0.2 }}
                                        >
                                            {/* Image on top */}
                                            <div className="h-[90px] overflow-hidden bg-gray-50">
                                                <motion.img
                                                    src={cat.image}
                                                    alt={cat.name}
                                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                                />
                                            </div>

                                            {/* Content below */}
                                            <div className="flex-1 p-2 flex flex-col justify-between">
                                                {/* Title */}
                                                <h3 className="font-semibold text-xs text-gray-800 text-center leading-tight">
                                                    {cat.name}
                                                </h3>

                                                {/* Explore more button */}
                                                <div className="text-center mt-1">
                                                    <motion.span
                                                        className="text-[10px] text-[#008000] font-medium px-1.5 py-0.5 bg-green-50 rounded-full inline-block"
                                                        whileHover={{ scale: 1.05 }}
                                                    >
                                                        Explore More
                                                    </motion.span>
                                                </div>
                                            </div>
                                        </motion.div>
                                    </Link>
                                    {/* Desktop Layout: Keep original design for larger screens */}
                                    <div className="hidden sm:block">
                                        {/* Hexagon Background Shape */}
                                        <motion.div
                                            className="absolute inset-0 bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-md z-0 overflow-hidden"
                                            whileHover={{
                                                scale: 1.01,
                                                boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                            }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <div className="absolute inset-0 bg-gray-100 opacity-50 clip-path-hexagon transform translate-x-[-15%] translate-y-[-15%] scale-[1.3] group-hover:scale-[1.4] group-hover:rotate-12 transition-all duration-700"></div>
                                        </motion.div>
                                        {/* Category Content */}
                                        <Link
                                            to={`/subcategory/${cat.slug}`}
                                            className="relative z-10 p-4 sm:p-6 flex flex-col h-[18rem] sm:h-[21rem] justify-between"
                                        >
                                            <div className="flex items-center justify-between">
                                                <h3 className="font-semibold text-lg sm:text-xl text-gray-800 mb-2">
                                                    {cat.name}
                                                </h3>
                                                <motion.div
                                                    className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-[#008000] to-[#008000] text-white"
                                                    whileHover={{ rotate: 90 }}
                                                    transition={{ duration: 0.3 }}
                                                >
                                                    <svg
                                                        className="w-4 h-4 sm:w-5 sm:h-5"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M9 5l7 7-7 7"
                                                        />
                                                    </svg>
                                                </motion.div>
                                            </div>

                                            <div className="flex-grow flex items-center justify-center overflow-hidden py-4 sm:py-6">
                                                <motion.img
                                                    src={cat.image}
                                                    alt={cat.name}
                                                    className="w-full h-full object-cover max-h-36 sm:max-h-52"
                                                    whileHover={{ scale: 1.08, rotate: -2 }}
                                                    transition={{ duration: 0.5 }}
                                                />
                                            </div>

                                            <div className="flex justify-between items-end">
                                                <span className="text-xs sm:text-sm text-gray-500">
                                                    {cat.subcategories
                                                        ? `${cat.subcategories.length}+ options`
                                                        : "15+ options"}
                                                </span>
                                                <motion.span
                                                    className="text-xs sm:text-sm text-[#008000] font-medium border-b border-transparent group-hover:border-[#008000]"
                                                    whileHover={{ x: 3 }}
                                                >
                                                    Explore
                                                </motion.span>
                                            </div>
                                        </Link>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                        {/* Scroll indicators for mobile */}
                        <div className="flex justify-center mt-2 gap-1 sm:hidden">
                            {Array.from({ length: 4 }).map((_, i) => (
                                <div key={i} className="w-2 h-2 rounded-full bg-gray-300"></div>
                            ))}
                        </div>
                    </div>
                    {/* Quick-access Tags */}
                    <motion.div
                        className="mt-4 sm:mt-12 md:mt-16 pt-4 sm:pt-6 md:pt-8 border-t border-gray-200"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, delay: 0 }}
                    >
                        {" "}
                        <div className="flex flex-wrap gap-1 sm:gap-2 justify-center">
                            <span className="text-xs sm:text-sm text-gray-500 mr-1 sm:mr-2 pt-1 sm:pt-2 w-full text-center sm:w-auto">
                                Popular searches:
                            </span>
                            {[
                                { name: "Visiting cards", slug: "visiting-cards" },
                                { name: "Custom stickers", slug: "customized-stickers" },
                                { name: "Invitations", slug: "invitations" },
                                { name: "Marketing essentials", slug: "marketing-essentials" },
                                { name: "Custom stationary", slug: "custom-stationary" },
                                { name: "Office essentials", slug: "office-essentials" },
                            ].map((tag, idx) => (
                                <motion.a
                                    key={idx}
                                    href={`/subcategory/${tag.slug}`}
                                    className="px-1.5 sm:px-4 py-0.5 sm:py-1 bg-white rounded-full text-xs sm:text-sm border border-gray-200 text-gray-700 hover:bg-green-50 hover:text-[#008000] hover:border-[#008000] transition-colors duration-300"
                                    whileHover={{ y: -5, scale: 1.05 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    {tag.name}hshs
                                </motion.a>
                            ))}
                        </div>
                    </motion.div>
                </div>

                {/* Add this to your CSS (either inline style or in a stylesheet) */}
                <style jsx>{`
                    .clip-path-hexagon {
                        clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
                    }

                    /* Hide scrollbar for Chrome, Safari and Opera */
                    .scrollbar-hide::-webkit-scrollbar {
                        display: none;
                    }

                    /* Hide scrollbar for IE, Edge and Firefox */
                    .scrollbar-hide {
                        -ms-overflow-style: none; /* IE and Edge */
                        scrollbar-width: none; /* Firefox */
                    }
                `}</style>


                <motion.div
                    className="flex flex-col sm:flex-row justify-center items-center mt-8 sm:mt-12 gap-3 sm:gap-4"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                >
                    <div className="flex items-center bg-brand-light/30 rounded-full px-5 py-2">
                        <span className="text-brand-dark font-semibold mr-2">4.9</span>
                        <div className="flex">
                            {[...Array(5)].map((_, i) => (
                                <svg
                                    key={i}
                                    className="w-4 h-4 text-yellow-400"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                </svg>
                            ))}
                        </div>
                        <span className="text-sm text-gray-500 ml-2">from 394+ reviews</span>
                    </div>
                </motion.div>
            </section>

            {/* Hot Selling Section */}
            <section
                className="w-full py-8 sm:py-12 md:py-16 bg-white"
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-7xl mx-auto px-6 sm:px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="flex justify-between items-end mb-8 sm:mb-10">
                            <div>
                                <h2 className="text-xl sm:text-5xl font-bold mb-2 sm:mb-3 text-left text-black">Hot Selling</h2>
                                <p className="text-xs sm:text-xl text-gray-600 text-left max-w-3xl ">
                                    Discover our most popular products that customers love.
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    {hotSellingLoading ? (
                        <div className="text-center py-12">
                            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#008000]"></div>
                        </div>
                    ) : hotSellingError ? (
                        <div className="text-center py-12 text-red-500">
                            <p>Failed to load hot selling products</p>
                        </div>
                    ) : hotSellingData?.data?.products?.length > 0 ? (
                        <>
                            {/* Mobile Slider View */}
                            <div className="block sm:hidden relative">
                                <div
                                    className="overflow-hidden touch-pan-y"
                                    onTouchStart={handleHotSellingTouchStart}
                                    onTouchMove={handleHotSellingTouchMove}
                                    onTouchEnd={handleHotSellingTouchEnd}
                                >
                                    <div
                                        className="flex transition-transform duration-300 ease-in-out"
                                        style={{ transform: `translateX(-${hotSellingCurrentIndex * 100}%)` }}
                                    >
                                        {hotSellingProducts.slice(0, 4).map((product, idx) => {
                                            const getPricing = () => {
                                                if (!product.pricing || product.pricing.length === 0) return "Price on request";
                                                const firstPricing = product.pricing[0];
                                                if (!firstPricing) return "Price on request";
                                                const price = firstPricing.discountPrice || firstPricing.basePrice;
                                                const quantity = firstPricing.quantity || 0;
                                                return `${quantity} from ₹${price}`;
                                            };

                                            const features = product.features && product.features.length > 0
                                                ? product.features
                                                : [
                                                    "16pt thickness",
                                                    'our "feel good" premium paper',
                                                    "available in matte or gloss finish",
                                                    "great quality and great value",
                                                    "fsc® certified"
                                                ];

                                            return (
                                                <div
                                                    key={product._id}
                                                    className="w-full flex-shrink-0 px-2"
                                                >
                                                    <motion.div
                                                        initial={{ opacity: 0, y: 30 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.5 }}
                                                    >
                                                        <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 transition-all duration-300 flex flex-col">
                                                            <div className="aspect-square overflow-hidden bg-gray-50 relative">
                                                                <img
                                                                    src={product.images?.[0]?.url || "/placeholder.svg"}
                                                                    alt={product.name}
                                                                    className="w-full h-full object-cover"
                                                                />
                                                            </div>
                                                            <div className="p-2 sm:p-4 flex flex-col flex-grow">
                                                                <h3 className="font-bold text-black text-sm sm:text-lg mb-1 sm:mb-2 line-clamp-2">{product.name}</h3>
                                                                <p className="text-gray-700 text-xs sm:text-sm mb-2 sm:mb-4">{getPricing()}</p>
                                                                <ul className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-4 space-y-0.5 sm:space-y-1 flex-grow">
                                                                    {features.slice(0, 5).map((feature, fIdx) => (
                                                                        <li key={fIdx} className="flex items-start">
                                                                            <span className="mr-1 sm:mr-2 text-xs">•</span>
                                                                            <span className="line-clamp-1">{feature}</span>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                                <Link
                                                                    to={`/product/${product._id}`}
                                                                    className="w-full bg-[#008000] hover:bg-[#008000] text-white font-medium py-2 px-3 sm:py-3 sm:px-4 rounded-xl text-xs sm:text-base transition-colors duration-200 mt-auto block text-center"
                                                                >
                                                                    Start Buying
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </motion.div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Navigation Button */}
                                {hotSellingTotal > 1 && (
                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 z-10">
                                        <button
                                            onClick={handleHotSellingNext}
                                            className="w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors duration-200 shadow-md"
                                            aria-label="Next product"
                                        >
                                            <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </button>
                                    </div>
                                )}

                                {/* Slide Indicators */}
                                {hotSellingTotal > 1 && (
                                    <div className="flex gap-2 justify-center mt-4">
                                        {Array.from({ length: hotSellingTotal }).map((_, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() => setHotSellingCurrentIndex(idx)}
                                                className={`h-1.5 rounded-full transition-all duration-300 ${idx === hotSellingCurrentIndex ? "bg-[#008000] w-8" : "bg-gray-300 w-1.5"
                                                    }`}
                                                aria-label={`Go to slide ${idx + 1}`}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Desktop Grid View */}
                            <div className="hidden sm:grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
                                {hotSellingProducts.slice(0, 4).map((product, idx) => {
                                    const getPricing = () => {
                                        if (!product.pricing || product.pricing.length === 0) return "Price on request";
                                        const firstPricing = product.pricing[0];
                                        if (!firstPricing) return "Price on request";
                                        const price = firstPricing.discountPrice || firstPricing.basePrice;
                                        const quantity = firstPricing.quantity || 0;
                                        return `${quantity} from ₹${price}`;
                                    };

                                    const features = product.features && product.features.length > 0
                                        ? product.features
                                        : [
                                            "16pt thickness",
                                            'our "feel good" premium paper',
                                            "available in matte or gloss finish",
                                            "great quality and great value",
                                            "fsc® certified"
                                        ];

                                    return (
                                        <motion.div
                                            key={product._id}
                                            initial={{ opacity: 0, y: 30 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            viewport={{ once: true, margin: "-100px" }}
                                            transition={{ duration: 0.5, delay: idx * 0.1 }}
                                        >
                                            <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 flex flex-col">
                                                <div className="aspect-square overflow-hidden bg-gray-50 relative">
                                                    <img
                                                        src={product.images?.[0]?.url || "/placeholder.svg"}
                                                        alt={product.name}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                                <div className="p-2 sm:p-4 flex flex-col flex-grow">
                                                    <h3 className="font-bold text-black text-sm sm:text-lg mb-1 sm:mb-2 line-clamp-2">{product.name}</h3>
                                                    <p className="text-gray-700 text-xs sm:text-sm mb-2 sm:mb-4">{getPricing()}</p>
                                                    <ul className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-4 space-y-0.5 sm:space-y-1 flex-grow">
                                                        {features.slice(0, 5).map((feature, fIdx) => (
                                                            <li key={fIdx} className="flex items-start">
                                                                <span className="mr-1 sm:mr-2 text-xs">•</span>
                                                                <span className="line-clamp-1">{feature}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <Link
                                                        to={`/product/${product._id}`}
                                                        className="w-full bg-[#008000] hover:bg-[#008000] text-white font-medium py-2 px-3 sm:py-3 sm:px-4 rounded-xl text-xs sm:text-base transition-colors duration-200 mt-auto block text-center"
                                                    >
                                                        Start Buying
                                                    </Link>
                                                </div>
                                            </div>
                                        </motion.div>
                                    );
                                })}
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-12 text-gray-500">
                            <p>No hot selling products available at the moment</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Shape Options Section */}
            <section
                className="w-full py-8 sm:py-12 md:py-16 bg-white"
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-7xl mx-auto px-6 sm:px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="flex justify-between items-end mb-8 sm:mb-10">
                            <div>
                                <h2 className="text-xl sm:text-5xl font-bold mb-2 sm:mb-3 text-left text-black">Festive Specials</h2>
                                <p className="text-xs sm:text-xl text-gray-600 text-left max-w-3xl ">
                                    Select the perfect shape for festivals and make a lasting impression.
                                </p>
                                {/* <motion.a
                                    href="/marketing-essentials"
                                    className="text-[#008000] sm:hidden mt-4 sm:mt-0 font-medium flex items-center hover:underline text-xs -mb-6"
                                    whileHover={{ x: 5 }}
                                >
                                    View all festive designs
                                    <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                </motion.a> */}
                            </div>
                            {/* <motion.a
                                href="/marketing-essentials"
                                className="hidden sm:flex text-[#008000] font-medium items-center hover:underline text-xs sm:text-sm"
                                whileHover={{ x: 5 }}
                            >
                                View all
                                <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                            </motion.a> */}
                        </div>
                    </motion.div>

                    {festiveSpecialsLoading ? (
                        <div className="text-center py-12">
                            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#008000]"></div>
                        </div>
                    ) : festiveSpecialsError ? (
                        <div className="text-center py-12 text-red-500">
                            <p>Failed to load festive specials</p>
                        </div>
                    ) : festiveSpecialsData?.data?.products?.length > 0 ? (
                        <>
                            {/* Mobile Slider View */}
                            <div className="block sm:hidden relative">
                                <div
                                    className="overflow-hidden touch-pan-y"
                                    onTouchStart={handleFestiveSpecialsTouchStart}
                                    onTouchMove={handleFestiveSpecialsTouchMove}
                                    onTouchEnd={handleFestiveSpecialsTouchEnd}
                                >
                                    <div
                                        className="flex transition-transform duration-300 ease-in-out"
                                        style={{ transform: `translateX(-${festiveSpecialsCurrentIndex * 100}%)` }}
                                    >
                                        {festiveSpecialsProducts.slice(0, 4).map((product, idx) => {
                                            const getPricing = () => {
                                                if (!product.pricing || product.pricing.length === 0) return "Price on request";
                                                const firstPricing = product.pricing[0];
                                                if (!firstPricing) return "Price on request";
                                                const price = firstPricing.discountPrice || firstPricing.basePrice;
                                                const quantity = firstPricing.quantity || 0;
                                                return `${quantity} from ₹${price}`;
                                            };

                                            const features = product.features && product.features.length > 0
                                                ? product.features
                                                : [
                                                    "16pt thickness",
                                                    'our "feel good" premium paper',
                                                    "available in matte or gloss finish",
                                                    "great quality and great value",
                                                    "fsc® certified"
                                                ];

                                            return (
                                                <div
                                                    key={product._id}
                                                    className="w-full flex-shrink-0 px-2"
                                                >
                                                    <motion.div
                                                        initial={{ opacity: 0, y: 30 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.5 }}
                                                    >
                                                        <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 transition-all duration-300 flex flex-col">
                                                            <div className="aspect-square overflow-hidden bg-gray-50 relative">
                                                                <img
                                                                    src={product.images?.[0]?.url || "/placeholder.svg"}
                                                                    alt={product.name}
                                                                    className="w-full h-full object-cover"
                                                                />
                                                            </div>
                                                            <div className="p-2 sm:p-4 flex flex-col flex-grow">
                                                                <h3 className="font-bold text-black text-sm sm:text-lg mb-1 sm:mb-2 line-clamp-2">{product.name}</h3>
                                                                <p className="text-gray-700 text-xs sm:text-sm mb-2 sm:mb-4">{getPricing()}</p>
                                                                <ul className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-4 space-y-0.5 sm:space-y-1 flex-grow">
                                                                    {features.slice(0, 5).map((feature, fIdx) => (
                                                                        <li key={fIdx} className="flex items-start">
                                                                            <span className="mr-1 sm:mr-2 text-xs">•</span>
                                                                            <span className="line-clamp-1">{feature}</span>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                                <Link
                                                                    to={`/product/${product._id}`}
                                                                    className="w-full bg-[#008000] hover:bg-[#008000] text-white font-medium py-2 px-3 sm:py-3 sm:px-4 rounded-xl text-xs sm:text-base transition-colors duration-200 mt-auto block text-center"
                                                                >
                                                                    Start Buying
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </motion.div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Navigation Button */}
                                {festiveSpecialsTotal > 1 && (
                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 z-10">
                                        <button
                                            onClick={handleFestiveSpecialsNext}
                                            className="w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors duration-200 shadow-md"
                                            aria-label="Next product"
                                        >
                                            <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </button>
                                    </div>
                                )}

                                {/* Slide Indicators */}
                                {festiveSpecialsTotal > 1 && (
                                    <div className="flex gap-2 justify-center mt-4">
                                        {Array.from({ length: festiveSpecialsTotal }).map((_, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() => setFestiveSpecialsCurrentIndex(idx)}
                                                className={`h-1.5 rounded-full transition-all duration-300 ${idx === festiveSpecialsCurrentIndex ? "bg-[#008000] w-8" : "bg-gray-300 w-1.5"
                                                    }`}
                                                aria-label={`Go to slide ${idx + 1}`}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Desktop Grid View */}
                            <div className="hidden sm:grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
                                {festiveSpecialsProducts.slice(0, 4).map((product, idx) => {
                                    const getPricing = () => {
                                        if (!product.pricing || product.pricing.length === 0) return "Price on request";
                                        const firstPricing = product.pricing[0];
                                        if (!firstPricing) return "Price on request";
                                        const price = firstPricing.discountPrice || firstPricing.basePrice;
                                        const quantity = firstPricing.quantity || 0;
                                        return `${quantity} from ₹${price}`;
                                    };

                                    const features = product.features && product.features.length > 0
                                        ? product.features
                                        : [
                                            "16pt thickness",
                                            'our "feel good" premium paper',
                                            "available in matte or gloss finish",
                                            "great quality and great value",
                                            "fsc® certified"
                                        ];

                                    return (
                                        <motion.div
                                            key={product._id}
                                            initial={{ opacity: 0, y: 30 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            viewport={{ once: true, margin: "-100px" }}
                                            transition={{ duration: 0.5, delay: idx * 0.1 }}
                                        >
                                            <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 flex flex-col">
                                                <div className="aspect-square overflow-hidden bg-gray-50 relative">
                                                    <img
                                                        src={product.images?.[0]?.url || "/placeholder.svg"}
                                                        alt={product.name}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                                <div className="p-2 sm:p-4 flex flex-col flex-grow">
                                                    <h3 className="font-bold text-black text-sm sm:text-lg mb-1 sm:mb-2 line-clamp-2">{product.name}</h3>
                                                    <p className="text-gray-700 text-xs sm:text-sm mb-2 sm:mb-4">{getPricing()}</p>
                                                    <ul className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-4 space-y-0.5 sm:space-y-1 flex-grow">
                                                        {features.slice(0, 5).map((feature, fIdx) => (
                                                            <li key={fIdx} className="flex items-start">
                                                                <span className="mr-1 sm:mr-2 text-xs">•</span>
                                                                <span className="line-clamp-1">{feature}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <Link
                                                        to={`/product/${product._id}`}
                                                        className="w-full bg-[#008000] hover:bg-[#008000] text-white font-medium py-2 px-3 sm:py-3 sm:px-4 rounded-xl text-xs sm:text-base transition-colors duration-200 mt-auto block text-center"
                                                    >
                                                        Start Buying
                                                    </Link>
                                                </div>
                                            </div>
                                        </motion.div>
                                    );
                                })}
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-12 text-gray-500">
                            <p>No festive specials available at the moment</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Specialty Options Section */}
            <section
                className="w-full py-8 sm:py-12 md:py-16 bg-white"
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-7xl mx-auto px-6 sm:px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="flex justify-between items-end mb-8 sm:mb-10">
                            <div>
                                <h2 className="text-xl sm:text-5xl font-bold mb-2 sm:mb-3 text-left text-black">
                                    Inhouse Titles (Our Publications)
                                </h2>
                                <p className="text-xs sm:text-xl text-gray-600 text-left max-w-3xl">
                                    Explore our exclusive range of inhouse titles, crafted with care and expertise.
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    {inhousePublicationsLoading ? (
                        <div className="text-center py-12">
                            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#008000]"></div>
                        </div>
                    ) : inhousePublicationsError ? (
                        <div className="text-center py-12 text-red-500">
                            <p>Failed to load inhouse publications</p>
                        </div>
                    ) : inhousePublicationsData?.data?.products?.length > 0 ? (
                        <>
                            <div className="block sm:hidden relative">
                                <div
                                    className="overflow-hidden touch-pan-y"
                                    onTouchStart={handleInhousePublicationsTouchStart}
                                    onTouchMove={handleInhousePublicationsTouchMove}
                                    onTouchEnd={handleInhousePublicationsTouchEnd}
                                >
                                    <div
                                        className="flex transition-transform duration-300 ease-in-out"
                                        style={{ transform: `translateX(-${inhousePublicationsCurrentIndex * 100}%)` }}
                                    >
                                        {inhousePublicationsList.slice(0, 4).map((product, idx) => {
                                            const getPricing = () => {
                                                if (!product.pricing || product.pricing.length === 0) return "Price on request";
                                                const firstPricing = product.pricing[0];
                                                if (!firstPricing) return "Price on request";
                                                const price = firstPricing.discountPrice || firstPricing.basePrice;
                                                const quantity = firstPricing.quantity || 0;
                                                return `${quantity} from ₹${price}`;
                                            };

                                            const features = product.features && product.features.length > 0
                                                ? product.features
                                                : [
                                                    "16pt thickness",
                                                    'our "feel good" premium paper',
                                                    "available in matte or gloss finish",
                                                    "great quality and great value",
                                                    "fsc® certified"
                                                ];

                                            return (
                                                <div
                                                    key={product._id}
                                                    className="w-full flex-shrink-0 px-2"
                                                >
                                                    <motion.div
                                                        initial={{ opacity: 0, y: 30 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.5 }}
                                                    >
                                                        <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 transition-all duration-300 flex flex-col">
                                                            <div className="aspect-square overflow-hidden bg-gray-50 relative">
                                                                <img
                                                                    src={product.images?.[0]?.url || "/placeholder.svg"}
                                                                    alt={product.name}
                                                                    className="w-full h-full object-cover"
                                                                />
                                                            </div>
                                                            <div className="p-2 sm:p-4 flex flex-col flex-grow">
                                                                <h3 className="font-bold text-black text-sm sm:text-lg mb-1 sm:mb-2 line-clamp-2">{product.name}</h3>
                                                                <p className="text-gray-700 text-xs sm:text-sm mb-2 sm:mb-4">{getPricing()}</p>
                                                                <ul className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-4 space-y-0.5 sm:space-y-1 flex-grow">
                                                                    {features.slice(0, 5).map((feature, fIdx) => (
                                                                        <li key={fIdx} className="flex items-start">
                                                                            <span className="mr-1 sm:mr-2 text-xs">•</span>
                                                                            <span className="line-clamp-1">{feature}</span>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                                <Link
                                                                    to={`/product/${product._id}`}
                                                                    className="w-full bg-[#008000] hover:bg-[#008000] text-white font-medium py-2 px-3 sm:py-3 sm:px-4 rounded-xl text-xs sm:text-base transition-colors duration-200 mt-auto block text-center"
                                                                >
                                                                    Start Buying
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </motion.div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {inhousePublicationsTotal > 1 && (
                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 z-10">
                                        <button
                                            onClick={handleInhousePublicationsNext}
                                            className="w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors duration-200 shadow-md"
                                            aria-label="Next product"
                                        >
                                            <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </button>
                                    </div>
                                )}

                                {inhousePublicationsTotal > 1 && (
                                    <div className="flex gap-2 justify-center mt-4">
                                        {Array.from({ length: inhousePublicationsTotal }).map((_, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() => setInhousePublicationsCurrentIndex(idx)}
                                                className={`h-1.5 rounded-full transition-all duration-300 ${idx === inhousePublicationsCurrentIndex ? "bg-[#008000] w-8" : "bg-gray-300 w-1.5"
                                                    }`}
                                                aria-label={`Go to slide ${idx + 1}`}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="hidden sm:grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
                                {inhousePublicationsList.slice(0, 4).map((product, idx) => {
                                    const getPricing = () => {
                                        if (!product.pricing || product.pricing.length === 0) return "Price on request";
                                        const firstPricing = product.pricing[0];
                                        if (!firstPricing) return "Price on request";
                                        const price = firstPricing.discountPrice || firstPricing.basePrice;
                                        const quantity = firstPricing.quantity || 0;
                                        return `${quantity} from ₹${price}`;
                                    };

                                    const features = product.features && product.features.length > 0
                                        ? product.features
                                        : [
                                            "16pt thickness",
                                            'our "feel good" premium paper',
                                            "available in matte or gloss finish",
                                            "great quality and great value",
                                            "fsc® certified"
                                        ];

                                    return (
                                        <motion.div
                                            key={product._id}
                                            initial={{ opacity: 0, y: 30 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            viewport={{ once: true, margin: "-100px" }}
                                            transition={{ duration: 0.5, delay: idx * 0.1 }}
                                        >
                                            <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 flex flex-col">
                                                <div className="aspect-square overflow-hidden bg-gray-50 relative">
                                                    <img
                                                        src={product.images?.[0]?.url || "/placeholder.svg"}
                                                        alt={product.name}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                                <div className="p-2 sm:p-4 flex flex-col flex-grow">
                                                    <h3 className="font-bold text-black text-sm sm:text-lg mb-1 sm:mb-2 line-clamp-2">{product.name}</h3>
                                                    <p className="text-gray-700 text-xs sm:text-sm mb-2 sm:mb-4">{getPricing()}</p>
                                                    <ul className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-4 space-y-0.5 sm:space-y-1 flex-grow">
                                                        {features.slice(0, 5).map((feature, fIdx) => (
                                                            <li key={fIdx} className="flex items-start">
                                                                <span className="mr-1 sm:mr-2 text-xs">•</span>
                                                                <span className="line-clamp-1">{feature}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <Link
                                                        to={`/product/${product._id}`}
                                                        className="w-full bg-[#008000] hover:bg-[#008000] text-white font-medium py-2 px-3 sm:py-3 sm:px-4 rounded-xl text-xs sm:text-base transition-colors duration-200 mt-auto block text-center"
                                                    >
                                                        Start Buying
                                                    </Link>
                                                </div>
                                            </div>
                                        </motion.div>
                                    );
                                })}
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-12 text-gray-500">
                            <p>No inhouse publications available at the moment</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Paper Options Section */}
            <section
                className="w-full py-10 sm:py-12 md:py-16 bg-[#f8faf8]"
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-7xl mx-auto px-6 sm:px-8 ">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="flex justify-between items-end mb-8 sm:mb-10">
                            <div>
                                <h2 className="text-xl sm:text-5xl font-bold mb-2 sm:mb-3 text-left text-black">Design Templates</h2>
                                <p className="text-xs sm:text-xl text-gray-600 text-left max-w-3xl">
                                    Choose from a variety of professionally designed templates to kickstart your
                                    project.
                                </p>
                                <motion.a
                                    href="/templates"
                                    className="text-[#008000] sm:hidden mt-4 sm:mt-0 font-medium flex items-center hover:underline text-xs -mb-6"
                                    whileHover={{ x: 5 }}
                                >
                                    View all
                                    <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                </motion.a>
                            </div>
                            <motion.a
                                href="/templates"
                                className="hidden sm:flex text-[#008000] font-medium items-center hover:underline text-xs sm:text-sm"
                                whileHover={{ x: 5 }}
                            >
                                View all
                                <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                            </motion.a>
                        </div>
                    </motion.div>

                    {featuredTemplatesLoading ? (
                        <div className="text-center py-12">
                            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#008000]"></div>
                        </div>
                    ) : featuredTemplatesError ? (
                        <div className="text-center py-12 text-red-500">
                            <p>Failed to load templates</p>
                        </div>
                    ) : featuredTemplatesData?.data?.templates?.length > 0 ? (
                        <>
                            {/* Mobile Slider View */}
                            <div className="block sm:hidden relative">
                                <div
                                    className="overflow-hidden touch-pan-y"
                                    onTouchStart={handleDesignTemplatesTouchStart}
                                    onTouchMove={handleDesignTemplatesTouchMove}
                                    onTouchEnd={handleDesignTemplatesTouchEnd}
                                >
                                    <div
                                        className="flex transition-transform duration-300 ease-in-out"
                                        style={{ transform: `translateX(-${designTemplatesCurrentIndex * 100}%)` }}
                                    >
                                        {designTemplatesList.slice(0, 4).map((template, idx) => {
                                            const getTemplatePrice = () => {
                                                if (template.price === 0 || !template.price) return "Free";
                                                return `₹${template.price}`;
                                            };

                                            const features = template.tags && template.tags.length > 0
                                                ? template.tags.slice(0, 5)
                                                : [
                                                    "Professional design",
                                                    "High resolution",
                                                    "Easy to customize",
                                                    "Multiple formats",
                                                    "Ready to print"
                                                ];

                                            return (
                                                <div
                                                    key={template._id}
                                                    className="w-full flex-shrink-0 px-2"
                                                >
                                                    <motion.div
                                                        initial={{ opacity: 0, y: 30 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.5 }}
                                                        className="h-full"
                                                    >
                                                        <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 transition-all duration-300 flex flex-col h-full">
                                                            <div className="aspect-square overflow-hidden bg-gray-50 relative">
                                                                <img
                                                                    src={template.previewImage?.url || template.thumbnail?.url || "/placeholder.svg"}
                                                                    alt={template.name}
                                                                    className="w-full h-full object-cover"
                                                                />
                                                            </div>
                                                            <div className="p-2 sm:p-4 flex flex-col flex-grow">
                                                                <h3 className="font-bold text-black text-sm sm:text-lg mb-1 sm:mb-2 line-clamp-2">{template.name}</h3>
                                                                <p className="text-gray-700 text-xs sm:text-sm mb-2 sm:mb-4">{getTemplatePrice()}</p>
                                                                <ul className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-4 space-y-0.5 sm:space-y-1 flex-grow">
                                                                    {features.map((feature, fIdx) => (
                                                                        <li key={fIdx} className="flex items-start">
                                                                            <span className="mr-1 sm:mr-2 text-xs">•</span>
                                                                            <span className="line-clamp-1">{feature}</span>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                                <button
                                                                    onClick={() => {
                                                                        if (template.canvaLink) {
                                                                            window.open(template.canvaLink, '_blank', 'noopener,noreferrer');
                                                                        } else {
                                                                            window.location.href = `/templates/${template._id}`;
                                                                        }
                                                                    }}
                                                                    className="w-full bg-[#008000] hover:bg-[#008000] text-white font-medium py-2 px-3 sm:py-3 sm:px-4 rounded-xl text-xs sm:text-base transition-colors duration-200 mt-auto block text-center"
                                                                >
                                                                    View Template
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </motion.div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Navigation Button */}
                                {designTemplatesTotal > 1 && (
                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 z-10">
                                        <button
                                            onClick={handleDesignTemplatesNext}
                                            className="w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors duration-200 shadow-md"
                                            aria-label="Next template"
                                        >
                                            <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </button>
                                    </div>
                                )}

                                {/* Slide Indicators */}
                                {designTemplatesTotal > 1 && (
                                    <div className="flex gap-2 justify-center mt-4">
                                        {Array.from({ length: designTemplatesTotal }).map((_, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() => setDesignTemplatesCurrentIndex(idx)}
                                                className={`h-1.5 rounded-full transition-all duration-300 ${idx === designTemplatesCurrentIndex ? "bg-[#008000] w-8" : "bg-gray-300 w-1.5"
                                                    }`}
                                                aria-label={`Go to slide ${idx + 1}`}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Desktop Grid View */}
                            <div className="hidden sm:grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
                                {designTemplatesList.slice(0, 4).map((template, idx) => {
                                    const getTemplatePrice = () => {
                                        if (template.price === 0 || !template.price) return "Free";
                                        return `₹${template.price}`;
                                    };

                                    const features = template.tags && template.tags.length > 0
                                        ? template.tags.slice(0, 5)
                                        : [
                                            "Professional design",
                                            "High resolution",
                                            "Easy to customize",
                                            "Multiple formats",
                                            "Ready to print"
                                        ];

                                    return (
                                        <motion.div
                                            key={template._id}
                                            initial={{ opacity: 0, y: 30 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            viewport={{ once: true, margin: "-100px" }}
                                            transition={{ duration: 0.5, delay: idx * 0.1 }}
                                            className="h-full"
                                        >
                                            <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 flex flex-col h-full">
                                                <div className="aspect-square overflow-hidden bg-gray-50 relative">
                                                    <img
                                                        src={template.previewImage?.url || template.thumbnail?.url || "/placeholder.svg"}
                                                        alt={template.name}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                                <div className="p-2 sm:p-4 flex flex-col flex-grow">
                                                    <h3 className="font-bold text-black text-sm sm:text-lg mb-1 sm:mb-2 line-clamp-2">{template.name}</h3>
                                                    <p className="text-gray-700 text-xs sm:text-sm mb-2 sm:mb-4">{getTemplatePrice()}</p>
                                                    <ul className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-4 space-y-0.5 sm:space-y-1 flex-grow">
                                                        {features.map((feature, fIdx) => (
                                                            <li key={fIdx} className="flex items-start">
                                                                <span className="mr-1 sm:mr-2 text-xs">•</span>
                                                                <span className="line-clamp-1">{feature}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <button
                                                        onClick={() => {
                                                            if (template.canvaLink) {
                                                                window.open(template.canvaLink, '_blank', 'noopener,noreferrer');
                                                            } else {
                                                                window.location.href = `/templates/${template._id}`;
                                                            }
                                                        }}
                                                        className="w-full bg-[#008000] hover:bg-[#008000] text-white font-medium py-2 px-3 sm:py-3 sm:px-4 rounded-xl text-xs sm:text-base transition-colors duration-200 mt-auto block text-center"
                                                    >
                                                        View Template
                                                    </button>
                                                </div>
                                            </div>
                                        </motion.div>
                                    );
                                })}
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-12 text-gray-500">
                            <p>No featured templates available at the moment</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Featured Offers Section */}
            <FeaturedOffers />

            {/* How It Works Section - Mobile Responsive */}
            <section
                className="w-full py-10 sm:py-12 md:py-16 bg-gradient-to-b from-white to-[#f3f5f3]"
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <motion.div
                        className="text-center mb-8 sm:mb-10"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 className="text-xl sm:text-4xl font-bold mb-1 sm:mb-4">
                            Create Your Print <span className="text-[#008000]">in 4 Easy Steps</span>
                        </h2>
                        <p className="text-sm sm:text-xl text-gray-600 max-w-2xl mx-2 sm:mx-auto">
                            Our streamlined process makes it simple to get exactly what you need, from browsing options
                            to receiving your finished products.
                        </p>
                    </motion.div>

                    <div className="relative">
                        <div className="absolute top-24 sm:top-1/2 left-4 sm:left-0 w-0.5 sm:w-full h-[calc(100%-80px)] sm:h-0.5 bg-gray-200 sm:-translate-y-1/2 hidden sm:block"></div>

                        <div className="grid text-sm sm:text-base grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6 md:gap-10 relative">
                            {[
                                {
                                    number: 1,
                                    title: "Choose Your Product",
                                    description: "Browse our wide range of high-quality print products and options.",
                                    icon: (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-7 h-7 sm:w-8 sm:h-8"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
                                            <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
                                        </svg>
                                    ),
                                },
                                {
                                    number: 2,
                                    title: "Customize Design",
                                    description: "Select your shape, paper type, and finish to match your preferences.",
                                    icon: (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-7 h-7 sm:w-8 sm:h-8"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M12 20h9"></path>
                                            <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                                        </svg>
                                    ),
                                },
                                {
                                    number: 3,
                                    title: "Upload Artwork",
                                    description:
                                        "Upload your design or use our templates to create your perfect print.",
                                    icon: (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-7 h-7 sm:w-8 sm:h-8"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                            <polyline points="17 8 12 3 7 8"></polyline>
                                            <line x1="12" x2="12" y1="3" y2="15"></line>
                                        </svg>
                                    ),
                                },
                                {
                                    number: 4,
                                    title: "Place Your Order",
                                    description: "Review your proof, complete payment, and wait for your delivery.",
                                    icon: (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-7 h-7 sm:w-8 sm:h-8"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <rect width="16" height="16" x="4" y="4" rx="2"></rect>
                                            <path d="m9 12 2 2 4-4"></path>
                                        </svg>
                                    ),
                                },
                            ].map((step, idx) => (
                                <motion.div
                                    key={idx}
                                    className="relative z-10 mx-2 "
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-100px" }}
                                    transition={{ duration: 0.6, delay: idx * 0.1 }}
                                >
                                    <div className="absolute top-0 left-7 w-0.5 h-full bg-gray-200 sm:hidden"></div>

                                    <div className="bg-white rounded-xl p-6 sm:p-8 shadow-md border border-gray-100 h-full transition-all duration-300 hover:shadow-xl hover:-translate-y-2 pl-16 sm:pl-6 ml-0 sm:ml-0">
                                        <div className="w-10 h-10 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full bg-gradient-to-br from-[#008000] to-[#008000] flex items-center justify-center text-white text-lg sm:text-2xl font-bold mb-6 shadow-md absolute left-2 sm:left-auto top-6 sm:top-auto sm:relative sm:mx-auto">
                                            {step.number}
                                        </div>

                                        <div className="flex flex-col items-start sm:items-center mt-0 sm:mt-0">
                                            <div className="text-[#008000] mb-4 sm:mt-6">{step.icon}</div>

                                            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:text-center">
                                                {step.title}
                                            </h3>
                                            <p className="text-gray-600 sm:text-center">{step.description}</p>
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                    <motion.div
                        className="flex justify-center mt-8 sm:mt-12 md:mt-16"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, delay: 0.5 }}
                    >
                        <Link to="/templates">
                            <motion.button
                                className="px-4 sm:px-8 md:px-10 py-2 sm:py-3 md:py-4 bg-[#008000] text-white text-sm sm:text-lg font-semibold shadow-lg hover:bg-[#008000] transition-all duration-300 rounded-xl"
                                whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(0,0,0,0.2)" }}
                                whileTap={{ scale: 0.98 }}
                            >
                                Start Creating Now
                            </motion.button>
                        </Link>
                    </motion.div>
                </div>
            </section>

            {/* Why Kigo Print Section */}
            <section
                className="w-full py-12 sm:py-20 md:py-28 bg-gradient-to-b from-[#f3f5f3] to-white overflow-hidden"
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative">
                    {/* Background decorations */}
                    <div className="absolute -top-24 -right-24 w-64 h-64 bg-green-50 rounded-full opacity-70 blur-3xl"></div>
                    <div className="absolute -bottom-32 -left-32 w-80 h-80 bg-green-50 rounded-full opacity-70 blur-3xl"></div>

                    <motion.div
                        className="text-center mb-8 sm:mb-12 md:mb-16 relative z-10"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 className="text-xl sm:text-4xl font-bold mb-1 sm:mb-4">
                            Why Choose <span className="text-[#008000]">Kigo Prints?</span>
                        </h2>
                        <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
                            We've built our reputation on exceptional quality, outstanding service, and innovative
                            solutions for all your printing needs.
                        </p>
                    </motion.div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-10 mx-2">
                        {[
                            {
                                icon: (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-10 h-10"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <polyline points="12 6 12 12 16 14"></polyline>
                                    </svg>
                                ),
                                title: "Fast Turnaround Times",
                                description:
                                    "Get your prints delivered in record time with our Kigo printing options and efficient production process.",
                                color: "from-green-50 to-green-100",
                                iconBg: "bg-green-100",
                                delay: 0,
                            },
                            {
                                icon: (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-10 h-10"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M12 2L4 10l1 2h14l1-2-8-8z"></path>
                                        <path d="M9 14v6"></path>
                                        <path d="M15 14v6"></path>
                                        <path d="M12 14v6"></path>
                                    </svg>
                                ),
                                title: "Premium Materials",
                                description:
                                    "We use only the highest quality papers, inks, and finishes to ensure your prints look and feel professional.",
                                color: "from-blue-50 to-blue-100",
                                iconBg: "bg-blue-100",
                                delay: 0.1,
                            },
                            {
                                icon: (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-10 h-10"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                                        <line x1="2" x2="22" y1="10" y2="10"></line>
                                        <line x1="7" x2="7" y1="15" y2="15"></line>
                                        <line x1="11" x2="11" y1="15" y2="15"></line>
                                    </svg>
                                ),
                                title: "Competitive Pricing",
                                description:
                                    "Enjoy professional printing services at budget-friendly prices with volume discounts and regular promotions.",
                                color: "from-amber-50 to-amber-100",
                                iconBg: "bg-amber-100",
                                delay: 0.2,
                            },
                            {
                                icon: (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-10 h-10"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
                                        <path d="M13 5v2"></path>
                                        <path d="M13 17v2"></path>
                                        <path d="M13 11v2"></path>
                                        <path d="M8 5h1"></path>
                                        <path d="M8 21h1"></path>
                                        <path d="M14 5h1"></path>
                                        <path d="M14 21h1"></path>
                                        <path d="M3 9v1"></path>
                                        <path d="M21 9v1"></path>
                                        <path d="M3 14v1"></path>
                                        <path d="M21 14v1"></path>
                                    </svg>
                                ),
                                title: "Advanced Technology",
                                description:
                                    "Our state-of-the-art printing technology ensures crisp, vibrant, and consistent results for every project.",
                                color: "from-purple-50 to-purple-100",
                                iconBg: "bg-purple-100",
                                delay: 0.3,
                            },
                            {
                                icon: (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-10 h-10"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M5 3a2 2 0 0 0-2 2"></path>
                                        <path d="M19 3a2 2 0 0 1 2 2"></path>
                                        <path d="M21 19a2 2 0 0 1-2 2"></path>
                                        <path d="M5 21a2 2 0 0 1-2-2"></path>
                                        <path d="M9 3h1"></path>
                                        <path d="M9 21h1"></path>
                                        <path d="M14 3h1"></path>
                                        <path d="M14 21h1"></path>
                                        <path d="M3 9v1"></path>
                                        <path d="M21 9v1"></path>
                                        <path d="M3 14v1"></path>
                                        <path d="M21 14v1"></path>
                                    </svg>
                                ),
                                title: "Easy Customization",
                                description:
                                    "Create personalized designs with our intuitive online tools, or upload your own artwork for a perfect print.",
                                color: "from-emerald-50 to-emerald-100",
                                iconBg: "bg-emerald-100",
                                delay: 0.4,
                            },
                            {
                                icon: (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-10 h-10"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M7 11v12"></path>
                                        <path d="M15 5v18"></path>
                                        <path d="M7 15a4 4 0 0 1 4-4h4"></path>
                                        <path d="M11 7a4 4 0 0 0-4 4h12"></path>
                                    </svg>
                                ),
                                title: "Eco-Friendly Options",
                                description:
                                    "Choose from our range of sustainable papers and eco-conscious production methods for greener printing.",
                                color: "from-teal-50 to-teal-100",
                                iconBg: "bg-teal-100",
                                delay: 0.5,
                            },
                        ].map((feature, idx) => (
                            <motion.div
                                key={idx}
                                className="relative"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-100px" }}
                                transition={{ duration: 0.5, delay: feature.delay }}
                            >
                                <div
                                    className={`h-full rounded-xl overflow-hidden bg-gradient-to-br ${feature.color} border border-gray-100 p-7 sm:p-8 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col`}
                                >
                                    {/* <div
                                        className={`w-10 h-10 sm:w-16 sm:h-16 ${feature.iconBg} rounded-lg flex items-center justify-center text-[#008000] mb-6`}
                                    >
                                        {feature.icon}
                                    </div> */}
                                    <h3 className="text-sm sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">{feature.title}</h3>
                                    <p className="text-gray-600 flex-grow text-sm sm:text-base">
                                        {feature.description}
                                    </p>
                                    {/* 
                                    <motion.div
                                        className="mt-6 flex items-center text-[#008000] font-medium text-sm"
                                        whileHover={{ x: 5 }}
                                    >
                                        <span><Link to="/about-us">Learn more</Link></span>
                                        <svg
                                            className="w-4 h-4 ml-1"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M9 5l7 7-7 7"
                                            />
                                        </svg>
                                    </motion.div> */}
                                </div>

                                {/* Decorative number */}
                                {/* <div className="absolute -top-4 -right-4 w-8 h-8 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-400 font-bold text-xs">
                                    {idx + 1}
                                </div> */}
                            </motion.div>
                        ))}
                    </div>

                    <motion.div
                        className="mt-8 sm:mt-12 md:mt-16 text-center"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                    >
                        <div className="inline-flex items-center gap-2 bg-green-50 px-5 py-2 rounded-full border border-green-100">
                            <span className="flex h-6 w-6 rounded-full bg-[#008000] text-white items-center justify-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </span>
                            <span className="text-sm font-medium text-[#008000]">
                                Trusted by over 1K+ customers nationwide
                            </span>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* Additional Products Section
      <section className="w-full py-12 sm:py-16 md:py-24 bg-[#f8faf8]" style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="mb-8 sm:mb-10 md:mb-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-xl sm:text-4xl font-bold mb-2 sm:mb-3">More Products & Services</h2>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end">
              <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mb-2 sm:mb-0">
                We offer a variety of printing solutions for all your business needs
              </p>
            </div>
          </motion.div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {[
              {
                name: "Visiting Cards",
                description: "100 cards starting @ 250 Rs",
                image: "/businesscard.jpg"
              },
              {
                name: "Letter Heads",
                description: "100 pcs starting @ 500 Rs",
                image: "https://placehold.co/600x400?text=Letter+Heads"
              },
              {
                name: "Envelopes",
                description: "100 pcs starting @ 900 Rs",
                image: "https://placehold.co/600x400?text=Envelopes"
              },
              {
                name: "Bill Books",
                description: "Starting @ 150 Rs per book",
                image: "https://placehold.co/600x400?text=Bill+Books"
              },
              {
                name: "Brochures",
                description: "100 pcs starting @ 3000 Rs",
                image: "https://placehold.co/600x400?text=Brochures"
              },
              {
                name: "Flyers",
                description: "1000 pcs starting @ 1500 Rs",
                image: "https://placehold.co/600x400?text=Flyers"
              },
              {
                name: "ID Cards",
                description: "Starting @ 80 Rs per card",
                image: "https://placehold.co/600x400?text=ID+Cards"
              },
              {
                name: "Rubber Stamps",
                description: "Starting @ 200 Rs",
                image: "https://placehold.co/600x400?text=Rubber+Stamps"
              }
            ].map((product, idx) => (
              <motion.div
                key={idx}
                className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: idx * 0.05 }}
                whileHover={{ y: -8 }}
              >
                <div className="h-48 bg-gray-100 overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.name} 
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" 
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-lg text-gray-800 mb-2">{product.name}</h3>
                  <p className="text-[#008000] text-sm font-medium mb-3">{product.description}</p>
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-gray-500">One day delivery available</span>
                    <motion.button 
                      className="text-[#008000] text-sm font-medium flex items-center"
                      whileHover={{ x: 5 }}
                    >
                      Order Now
                      <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          
          <div className="text-center mt-10">
            <motion.button 
              className="px-4 py-2 bg-[#008000] text-white text-sm font-semibold rounded-xl hover:bg-[#008000] transition shadow-md"
              whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(0,0,0,0.15)" }}
              whileTap={{ scale: 0.98 }}
            >
              View All Products
            </motion.button>
          </div>
        </div>
      </section> */}

            {/* Special Offers Section
      <section className="w-full py-8 sm:py-16 md:py-20 bg-white" style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[#008000] to-[#008000] rounded-2xl overflow-hidden shadow-xl">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="p-8 sm:p-10 md:p-12 flex flex-col justify-center">
                <h2 className="text-xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">Special Monsoon Offer!</h2>
                <p className="text-green-100 text-sm sm:text-lg mb-4 sm:mb-6">
                  Get 20% off on all business card orders above 500 pieces. Use code MONSOON20 at checkout.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <motion.button 
                    className="px-4 py-2 bg-white text-[#008000] text-sm font-bold rounded-xl hover:bg-green-50 transition shadow-md"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Order Now
                  </motion.button>
                  <motion.button 
                    className="px-4 py-2 bg-transparent border-2 border-white text-white text-sm font-semibold rounded-xl hover:bg-white/10 transition"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Learn More
                  </motion.button>
                </div>
                <p className="text-green-200 text-xs mt-6">*Terms & Conditions Apply. Offer valid until 31st July, 2023.</p>
              </div>
              <div className="hidden md:block relative">
                <img 
                  src="https://placehold.co/600x400?text=Special+Offer" 
                  alt="Special Offer" 
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-5 right-5 bg-yellow-500 text-white text-lg font-bold px-4 py-2 rounded-full transform rotate-12">
                  20% OFF
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

            {/* Customer Reviews Section */}
            <section
                className="w-full py-8 sm:py-16 md:py-24 bg-gradient-to-b from-[#f3f5f3] to-white "
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <motion.div
                        className="text-center mb-8 sm:mb-12 md:mb-16"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 className="text-xl sm:text-3xl md:text-4xl font-bold mb-1 sm:mb-4">
                            What Our <span className="text-[#008000]">Customers Say</span>
                        </h2>
                        <p className="text-sm sm:text-lg text-gray-600 max-w-2xl mx-auto">
                            Join thousands of satisfied customers who trust our printing services for their business and
                            personal needs.
                        </p>
                    </motion.div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
                        {[
                            {
                                name: "Pakhi Bajaj",
                                role: "Customer",
                                image: "https://lh3.googleusercontent.com/a/ACg8ocImIU09NQCbOzx7XYwiPJIym1L54gHqU7xfdFoC5MldA0yIQQ=w72-h72-p-rp-mo-br100",
                                review: "Super quality, quick completion and easy transaction. Highly recommend",
                                rating: 5,
                            },
                            {
                                name: "Darsh Kale",
                                role: "Customer",
                                image: "https://lh3.googleusercontent.com/a-/ALV-UjVqbK-q2sW-apQxEKLKTdH-FrLVBCecmA73nHLUxSEnZ0cXgvg=w36-h36-p-rp-mo-br100",
                                review: "Fast and fine working method. No compromise with the quality ",
                                rating: 5,
                            },
                            {
                                name: "Divya Girghe",
                                role: "Customer",
                                image: "https://lh3.googleusercontent.com/a/ACg8ocJIJM9B7vbXZuWmo1Rw8YkfTJ87eYG6fO2S3nhW3yTag3V8og=w72-h72-p-rp-mo-br100",
                                review: "The picture quality is awesome and customised option are available",
                                rating: 5,
                            },
                        ].map((review, idx) => (
                            <motion.div
                                key={idx}
                                className="bg-white rounded-xl p-8 shadow-md border border-gray-100 relative mx-3"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-100px" }}
                                transition={{ duration: 0.5, delay: idx * 0.1 }}
                                whileHover={{ y: -10, boxShadow: "0 15px 30px rgba(0,0,0,0.1)" }}
                            >
                                {/* Quotation mark decoration */}
                                {/* <div className="absolute -top-5 -left-5 w-10 h-10 rounded-full bg-brand-light flex items-center justify-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5 text-brand-dark"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </div> */}

                                {/* Star Rating */}
                                <div className="flex mb-4">
                                    {[...Array(5)].map((_, i) => (
                                        <svg
                                            key={i}
                                            className={`w-5 h-5 ${i < review.rating ? "text-yellow-400" : "text-gray-300"
                                                }`}
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                        </svg>
                                    ))}
                                </div>

                                <p className="mb-6 text-gray-600 italic text-sm sm:text-base">"{review.review}"</p>

                                <div className="flex items-center">
                                    <img
                                        src={review.image}
                                        alt={review.name}
                                        className="w-12 h-12 rounded-full mr-4 border-2 border-brand-light"
                                    />
                                    <div>
                                        <h4 className="font-semibold text-gray-800">{review.name}</h4>
                                        <p className="text-sm text-gray-500">{review.role}</p>
                                    </div>
                                </div>

                                <div className="absolute bottom-0 right-0 w-20 h-20 overflow-hidden rounded-tl-xl">
                                    <div className="absolute bottom-0 right-0 w-full h-full bg-gradient-to-tl from-brand-light via-transparent to-transparent opacity-70"></div>
                                </div>
                            </motion.div>
                        ))}
                    </div>

                    <motion.div
                        className="flex flex-col sm:flex-row justify-center items-center mt-8 sm:mt-12 gap-3 sm:gap-4"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <div className="flex items-center bg-brand-light/30 rounded-full px-5 py-2">
                            <span className="text-brand-dark font-semibold mr-2">4.9</span>
                            <div className="flex">
                                {[...Array(5)].map((_, i) => (
                                    <svg
                                        key={i}
                                        className="w-4 h-4 text-yellow-400"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                    </svg>
                                ))}
                            </div>
                            <span className="text-sm text-gray-500 ml-2">from 394+ reviews</span>
                        </div>

                        <motion.a
                            href="#"
                            className="flex items-center text-brand-dark font-semibold"
                            whileHover={{ x: 5 }}
                        >
                            <Link to="https://www.google.com/maps/place/Vinod+Printers/@18.5578854,73.9228706,17z/data=!4m8!3m7!1s0x3bc2c167ec5f3801:0x4ab993e9b936d033!8m2!3d18.5578854!4d73.9254509!9m1!1b1!16s%2Fg%2F1tdc3p5x?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D">
                                <span>Read all customer reviews</span>
                            </Link>
                            <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                        </motion.a>
                    </motion.div>
                </div>
            </section>

            {/* FAQ Section with animations */}
            <section
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
                className="w-full py-8 sm:py-16 md:py-24 bg-white border-t border-b border-gray-100"
            >
                <div className="max-w-4xl mx-auto px-4 sm:px-6">
                    <motion.h2
                        className="text-xl sm:text-3xl font-bold text-center mb-4 sm:mb-12 mx-2 sm:mx-0"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        Frequently Asked Questions
                    </motion.h2>

                    <motion.div
                        className="divide-y divide-gray-200"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8 }}
                    >
                        {faqs.map((faq, idx) => (
                            <motion.details
                                key={idx}
                                className="py-5 group mx-3"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-100px" }}
                                transition={{ duration: 0.5, delay: idx * 0.1 }}
                            >
                                <summary className="cursor-pointer text-lg sm:text-xl font-semibold text-gray-800 group-open:text-[#008000] transition-colors flex items-center justify-between">
                                    {faq.question}
                                    <motion.span
                                        className="ml-2 text-[#008000] text-2xl"
                                        initial={{ rotate: 0 }}
                                        animate={{ rotate: [0, 0] }}
                                        variants={{
                                            open: { rotate: 45 },
                                            closed: { rotate: 0 },
                                        }}
                                    >
                                        +
                                    </motion.span>
                                </summary>
                                <motion.div
                                    className="mt-2 sm:mt-4 text-gray-600 text-sm sm:text-lg pl-2 pr-4 sm:pr-8"
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    {faq.answer}
                                </motion.div>
                            </motion.details>
                        ))}
                    </motion.div>
                </div>
            </section>

            {/* Subscribe Section with animations */}
            <section
                className="w-full py-8 sm:py-20 md:py-28 bg-[#f3f5f3]"
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-2xl sm:mx-auto px-4 sm:px-6 text-center mx-3">
                    <motion.h2
                        className="text-xl sm:text-3xl font-bold mb-2 sm:mb-5"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        Sign up for inspiration, offers, and news
                    </motion.h2>

                    <motion.p
                        className="mb-6 sm:mb-8 text-gray-600 text-base sm:text-lg"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        Get 20% off your first order, business tips, exclusive special offers and more.
                    </motion.p>

                    <motion.form
                        className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <motion.input
                            type="email"
                            placeholder="Enter your email"
                            className="flex-1 px-4 sm:px-6 py-3 sm:py-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#008000] text-base sm:text-lg shadow-sm"
                            whileFocus={{ scale: 1.01, boxShadow: "0 5px 15px rgba(0,0,0,0.1)" }}
                            transition={{ duration: 0.3 }}
                        />
                        <motion.button
                            type="submit"
                            className="px-4 sm:px-8 py-2 sm:py-4 bg-[#008000] text-white text-sm sm:text-lg font-semibold rounded-xl hover:bg-[#008000] transition shadow-md"
                            whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(0,0,0,0.15)" }}
                            whileTap={{ scale: 0.98 }}
                            transition={{ duration: 0.3 }}
                        >
                            <Link to="/signup">
                                Sign Up
                            </Link>
                        </motion.button>
                    </motion.form>
                </div>
            </section>

            {/* About Us Section with animations */}
            <section
                className="w-full py-12 sm:py-20 md:py-28 bg-gradient-to-b from-[#f3f5f3] to-green-50"
                style={{ fontFamily: '"Bricolage Grotesque", sans-serif' }}
            >
                <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
                    <motion.h2
                        className="text-xl sm:text-3xl font-bold mb-3 sm:mb-5"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                    >
                        About Us - Kigo Prints
                    </motion.h2>

                    <motion.h3
                        className="text-sm sm:text-2xl font-semibold text-[#008000] mb-2 sm:mb-4"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        Your One-Stop Solution for Quality Printing
                    </motion.h3>

                    <motion.p
                        className="text-sm sm:text-lg text-justify text-gray-700 mb-12 leading-relaxed max-w-4xl mx-4 sm:mx-auto"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        Kigo Prints provides high-quality printing solutions for businesses of all sizes. From business
                        cards to marketing materials, we deliver premium products with fast turnaround times and
                        exceptional customer service. Our one day delivery option ensures you get your prints when you
                        need them.
                    </motion.p>

                    <motion.div
                        className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 md:gap-8 text-left mb-8 sm:mb-12"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8 }}
                    >
                        {[
                            {
                                title: "Even Low Quantities @ Best Prices",
                                desc: "We offer low/ single product quantities at affordable prices.",
                            },
                            {
                                title: "High Quality Products and Easy Design",
                                desc: "Our wide selection of high-quality products and online design tools make it easy for you to customize and order your favourite products.",
                            },
                            {
                                title: "Free Replacement or Full Refund",
                                desc: "We stand by everything we sell. So if you're not satisfied, we'll make it right.",
                            },
                        ].map((item, idx) => (
                            <motion.div
                                key={idx}
                                className="bg-[#ffffff] p-8 rounded-xl shadow-md mx-3 sm:mx-0"
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-100px" }}
                                transition={{ duration: 0.5, delay: 0.3 + idx * 0.1 }}
                                whileHover={{ y: -8, boxShadow: "0 15px 30px rgba(0,0,0,0.1)" }}
                            >
                                <h4 className="font-bold text-sm sm:text-xl text-[#008000] mb-2 sm:mb-3">{item.title}</h4>
                                <p className="text-gray-700 text-sm sm:text-base">{item.desc}</p>
                            </motion.div>
                        ))}
                    </motion.div>

                    <Link to="/about-us">
                        <motion.button
                            className="inline-block px-6 sm:px-10 py-2 sm:py-4 bg-[#008000] text-white rounded-xl font-semibold shadow-lg hover:bg-[#008000] transition-all duration-300 text-sm sm:text-base"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{ duration: 0.6, delay: 0.5 }}
                            whileHover={{ scale: 1.05, boxShadow: "0 15px 30px rgba(0,0,0,0.15)" }}
                            whileTap={{ scale: 0.98 }}
                        >
                            Learn More About Us
                        </motion.button>
                    </Link>
                </div>
            </section>

            {/* Mobile-specific controls for fixed UI */}
            {/* <div className="fixed bottom-6 right-6 z-40 md:hidden">
        <motion.button
          className="w-14 h-14 rounded-full bg-[#008000] text-white shadow-lg flex items-center justify-center"
          whileTap={{ scale: 0.9 }}
        >
          <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
          </svg>
        </motion.button>
      </div> */}
        </>
    );
};

export default LandingPageV4;
